msgid ""
msgstr ""
"POT-Creation-Date: 2024-08-04 21:58+0800\n"
"MIME-Version: 1.0\n"
"Content-Type: text/plain; charset=UTF-8\n"
"Content-Transfer-Encoding: 8bit\n"
"X-Generator: @lingui/cli\n"
"Language: eo\n"
"Project-Id-Version: phanpy\n"
"Report-Msgid-Bugs-To: \n"
"PO-Revision-Date: 2024-10-14 15:38\n"
"Last-Translator: \n"
"Language-Team: Esperanto\n"
"Plural-Forms: nplurals=2; plural=(n != 1);\n"
"X-Crowdin-Project: phanpy\n"
"X-Crowdin-Project-ID: 703337\n"
"X-Crowdin-Language: eo\n"
"X-Crowdin-File: /main/src/locales/en.po\n"
"X-Crowdin-File-ID: 18\n"

#: src/components/account-block.jsx:135
msgid "Locked"
msgstr "Ŝlosita"

#: src/components/account-block.jsx:141
msgid "Posts: {0}"
msgstr "Afiŝoj: {0}"

#: src/components/account-block.jsx:146
msgid "Last posted: {0}"
msgstr "Laste afiŝita: {0}"

#: src/components/account-block.jsx:161
#: src/components/account-info.jsx:634
msgid "Automated"
msgstr "Aŭtomatigita"

#: src/components/account-block.jsx:168
#: src/components/account-info.jsx:639
#: src/components/status.jsx:480
#: src/pages/catchup.jsx:1471
msgid "Group"
msgstr "Grupo"

#: src/components/account-block.jsx:178
msgid "Mutual"
msgstr "Reciproka"

#: src/components/account-block.jsx:182
#: src/components/account-info.jsx:1680
msgid "Requested"
msgstr "Petita"

#: src/components/account-block.jsx:186
#: src/components/account-info.jsx:1671
msgid "Following"
msgstr "Sekvatoj"

#: src/components/account-block.jsx:190
#: src/components/account-info.jsx:1062
msgid "Follows you"
msgstr "Sekvas vin"

#: src/components/account-block.jsx:198
msgid "{followersCount, plural, one {# follower} other {# followers}}"
msgstr "{followersCount, plural, one {# sekvanto} other {# sekvantoj}}"

#: src/components/account-block.jsx:207
#: src/components/account-info.jsx:680
msgid "Verified"
msgstr "Kontrolita"

#: src/components/account-block.jsx:222
#: src/components/account-info.jsx:780
msgid "Joined <0>{0}</0>"
msgstr "Aliĝis <0>{0}</0>"

#: src/components/account-info.jsx:57
msgid "Forever"
msgstr "Por ĉiam"

#: src/components/account-info.jsx:377
msgid "Unable to load account."
msgstr "Ne eblas ŝargi konton."

#: src/components/account-info.jsx:385
msgid "Go to account page"
msgstr "Iri al konta paĝo"

#: src/components/account-info.jsx:413
#: src/components/account-info.jsx:702
#: src/components/account-info.jsx:732
msgid "Followers"
msgstr "Sekvantoj"

#. js-lingui-explicit-id
#: src/components/account-info.jsx:416
#: src/components/account-info.jsx:742
#: src/components/account-info.jsx:759
msgid "following.stats"
msgstr "Sekvatoj"

#: src/components/account-info.jsx:419
#: src/components/account-info.jsx:776
#: src/pages/account-statuses.jsx:484
#: src/pages/search.jsx:237
#: src/pages/search.jsx:384
msgid "Posts"
msgstr "Afiŝoj"

#: src/components/account-info.jsx:427
#: src/components/account-info.jsx:1118
#: src/components/compose.jsx:2488
#: src/components/media-alt-modal.jsx:45
#: src/components/media-modal.jsx:283
#: src/components/status.jsx:1703
#: src/components/status.jsx:1720
#: src/components/status.jsx:1844
#: src/components/status.jsx:2442
#: src/components/status.jsx:2445
#: src/pages/account-statuses.jsx:528
#: src/pages/accounts.jsx:109
#: src/pages/hashtag.jsx:199
#: src/pages/list.jsx:157
#: src/pages/public.jsx:114
#: src/pages/status.jsx:1181
#: src/pages/trending.jsx:471
msgid "More"
msgstr "Pli"

#: src/components/account-info.jsx:439
msgid "<0>{displayName}</0> has indicated that their new account is now:"
msgstr "<0>{displayName}</0> indikis, ke ilia nova konto nun estas:"

#: src/components/account-info.jsx:584
#: src/components/account-info.jsx:1276
msgid "Handle copied"
msgstr "Identigo kopiita"

#: src/components/account-info.jsx:587
#: src/components/account-info.jsx:1279
msgid "Unable to copy handle"
msgstr "Ne eblas kopii la tenilon"

#: src/components/account-info.jsx:593
#: src/components/account-info.jsx:1285
msgid "Copy handle"
msgstr "Kopii identigon"

#: src/components/account-info.jsx:599
msgid "Go to original profile page"
msgstr "Malfermi la originalan profilpaĝon"

#: src/components/account-info.jsx:606
msgid "View profile image"
msgstr "Vidi rolfiguron"

#: src/components/account-info.jsx:612
msgid "View profile header"
msgstr "Vidi fonbildon"

#: src/components/account-info.jsx:629
msgid "In Memoriam"
msgstr "Memore"

#: src/components/account-info.jsx:709
#: src/components/account-info.jsx:750
msgid "This user has chosen to not make this information available."
msgstr "Ĉi tiu uzanto elektis ne disponebligi ĉi tiun informon."

#: src/components/account-info.jsx:805
msgid "{0} original posts, {1} replies, {2} boosts"
msgstr "{0} originalaj afiŝoj, {1} respondoj, {2} diskonigoj"

#: src/components/account-info.jsx:821
msgid "{0, plural, one {{1, plural, one {Last 1 post in the past 1 day} other {Last 1 post in the past {2} days}}} other {{3, plural, one {Last {4} posts in the past 1 day} other {Last {5} posts in the past {6} days}}}}"
msgstr "{0, plural, one {{1, plural, one {Lasta afiŝo en la lasta tago} other {Lasta afiŝo en la pasintaj {2} tagoj}}} other {{3, plural, one {Lastaj {4} afiŝoj en la lasta tago} other {Lastaj {5} afiŝoj en la pasintaj {6} tagoj}}}}"

#: src/components/account-info.jsx:834
msgid "{0, plural, one {Last 1 post in the past year(s)} other {Last {1} posts in the past year(s)}}"
msgstr "{0, plural, one {Lasta afiŝo en la pasinta(j) jaro(j)} other {Lastaj {1} afiŝoj en la pasinta(j) jaro(j)}}"

#: src/components/account-info.jsx:858
#: src/pages/catchup.jsx:70
msgid "Original"
msgstr "Originala"

#: src/components/account-info.jsx:862
#: src/components/status.jsx:2233
#: src/pages/catchup.jsx:71
#: src/pages/catchup.jsx:1445
#: src/pages/catchup.jsx:2056
#: src/pages/status.jsx:904
#: src/pages/status.jsx:1506
msgid "Replies"
msgstr "Respondoj"

#: src/components/account-info.jsx:866
#: src/pages/catchup.jsx:72
#: src/pages/catchup.jsx:1447
#: src/pages/catchup.jsx:2068
#: src/pages/settings.jsx:1110
msgid "Boosts"
msgstr "Diskonigoj"

#: src/components/account-info.jsx:872
msgid "Post stats unavailable."
msgstr "Afiŝaj statistikoj ne disponeblaj."

#: src/components/account-info.jsx:903
msgid "View post stats"
msgstr "Vidi afiŝo-statistikojn"

#: src/components/account-info.jsx:1066
msgid "Last post: <0>{0}</0>"
msgstr "Lasta afiŝo: <0>{0}</0>"

#: src/components/account-info.jsx:1080
msgid "Muted"
msgstr "Silentigita"

#: src/components/account-info.jsx:1085
msgid "Blocked"
msgstr "Blokita"

#: src/components/account-info.jsx:1094
msgid "Private note"
msgstr "Persona noto"

#: src/components/account-info.jsx:1151
msgid "Mention <0>@{username}</0>"
msgstr "Mencii <0>@{username}</0>"

#: src/components/account-info.jsx:1163
msgid "Translate bio"
msgstr "Traduki biografion"

#: src/components/account-info.jsx:1174
msgid "Edit private note"
msgstr "Redakti personan noton"

#: src/components/account-info.jsx:1174
msgid "Add private note"
msgstr "Aldoni personan noton"

#: src/components/account-info.jsx:1194
msgid "Notifications enabled for @{username}'s posts."
msgstr "Ŝaltitaj sciigoj por afiŝoj de @{username}."

#: src/components/account-info.jsx:1195
msgid "Notifications disabled for @{username}'s posts."
msgstr "Malŝaltitaj sciigoj por afiŝoj de @{username}."

#: src/components/account-info.jsx:1207
msgid "Disable notifications"
msgstr "Malŝalti sciigojn"

#: src/components/account-info.jsx:1208
msgid "Enable notifications"
msgstr "Ŝalti sciigojn"

#: src/components/account-info.jsx:1225
msgid "Boosts from @{username} enabled."
msgstr "Diskonigoj de @{username} ŝaltitaj."

#: src/components/account-info.jsx:1226
msgid "Boosts from @{username} disabled."
msgstr "Diskonigoj de @{username} malŝaltitaj."

#: src/components/account-info.jsx:1237
msgid "Disable boosts"
msgstr "Malŝalti diskonigojn"

#: src/components/account-info.jsx:1237
msgid "Enable boosts"
msgstr "Ŝalti diskonigojn"

#: src/components/account-info.jsx:1253
#: src/components/account-info.jsx:1263
#: src/components/account-info.jsx:1864
msgid "Add/Remove from Lists"
msgstr "Aldoni/Forigi el Listoj"

#: src/components/account-info.jsx:1302
#: src/components/status.jsx:1143
msgid "Link copied"
msgstr "Ligilo kopiita"

#: src/components/account-info.jsx:1305
#: src/components/status.jsx:1146
msgid "Unable to copy link"
msgstr "Ne eblas kopii la ligilon"

#: src/components/account-info.jsx:1311
#: src/components/shortcuts-settings.jsx:1059
#: src/components/status.jsx:1152
#: src/components/status.jsx:3219
msgid "Copy"
msgstr "Kopii"

#: src/components/account-info.jsx:1326
#: src/components/shortcuts-settings.jsx:1077
#: src/components/status.jsx:1168
msgid "Sharing doesn't seem to work."
msgstr "Kunhavigo ŝajnas ne funkcii."

#: src/components/account-info.jsx:1332
#: src/components/status.jsx:1174
msgid "Share…"
msgstr "Diskonigi…"

#: src/components/account-info.jsx:1352
msgid "Unmuted @{username}"
msgstr "Nesilentigita @{username}"

#: src/components/account-info.jsx:1364
msgid "Unmute <0>@{username}</0>"
msgstr "Ne plu silentigi <0>@{username}</0>"

#: src/components/account-info.jsx:1380
msgid "Mute <0>@{username}</0>…"
msgstr "Silentigi <0>@{username}</0>…"

#: src/components/account-info.jsx:1412
msgid "Muted @{username} for {0}"
msgstr "Silentigita @{username} dum {0}"

#: src/components/account-info.jsx:1424
msgid "Unable to mute @{username}"
msgstr "Ne eblas silentigi @{username}"

#: src/components/account-info.jsx:1445
msgid "Remove <0>@{username}</0> from followers?"
msgstr "Ĉu forigi <0>@{username}</0> el sekvantoj?"

#: src/components/account-info.jsx:1465
msgid "@{username} removed from followers"
msgstr "@{username} forigita de sekvantoj"

#: src/components/account-info.jsx:1477
msgid "Remove follower…"
msgstr "Forigi sekvanton…"

#: src/components/account-info.jsx:1488
msgid "Block <0>@{username}</0>?"
msgstr "Ĉu bloki <0>@{username}</0>?"

#: src/components/account-info.jsx:1512
msgid "Unblocked @{username}"
msgstr "Malbloki @{username}"

#: src/components/account-info.jsx:1520
msgid "Blocked @{username}"
msgstr "Blokita @{username}"

#: src/components/account-info.jsx:1528
msgid "Unable to unblock @{username}"
msgstr "Ne eblas malbloki @{username}"

#: src/components/account-info.jsx:1530
msgid "Unable to block @{username}"
msgstr "Ne eblas bloki @{username}"

#: src/components/account-info.jsx:1540
msgid "Unblock <0>@{username}</0>"
msgstr "Malbloki <0>@{username}</0>"

#: src/components/account-info.jsx:1549
msgid "Block <0>@{username}</0>…"
msgstr "Bloki <0>@{username}</0>…"

#: src/components/account-info.jsx:1566
msgid "Report <0>@{username}</0>…"
msgstr "Raporti <0>@{username}</0>…"

#: src/components/account-info.jsx:1586
#: src/components/account-info.jsx:2097
msgid "Edit profile"
msgstr "Redakti la profilon"

#: src/components/account-info.jsx:1622
msgid "Withdraw follow request?"
msgstr "Ĉu nuligi peton por sekvado?"

#: src/components/account-info.jsx:1623
msgid "Unfollow @{0}?"
msgstr "Ĉu ĉesi sekvi @{0}?"

#: src/components/account-info.jsx:1674
msgid "Unfollow…"
msgstr "Ĉesi sekvi…"

#: src/components/account-info.jsx:1683
msgid "Withdraw…"
msgstr "Nuligi…"

#: src/components/account-info.jsx:1690
#: src/components/account-info.jsx:1694
#: src/pages/hashtag.jsx:261
msgid "Follow"
msgstr "Sekvi"

#: src/components/account-info.jsx:1805
#: src/components/account-info.jsx:1859
#: src/components/account-info.jsx:1992
#: src/components/account-info.jsx:2092
#: src/components/account-sheet.jsx:37
#: src/components/compose.jsx:818
#: src/components/compose.jsx:2444
#: src/components/compose.jsx:2917
#: src/components/compose.jsx:3125
#: src/components/compose.jsx:3355
#: src/components/drafts.jsx:58
#: src/components/embed-modal.jsx:12
#: src/components/generic-accounts.jsx:142
#: src/components/keyboard-shortcuts-help.jsx:39
#: src/components/list-add-edit.jsx:33
#: src/components/media-alt-modal.jsx:33
#: src/components/media-modal.jsx:247
#: src/components/notification-service.jsx:156
#: src/components/report-modal.jsx:75
#: src/components/shortcuts-settings.jsx:230
#: src/components/shortcuts-settings.jsx:583
#: src/components/shortcuts-settings.jsx:783
#: src/components/status.jsx:2944
#: src/components/status.jsx:3183
#: src/components/status.jsx:3681
#: src/pages/accounts.jsx:36
#: src/pages/catchup.jsx:1581
#: src/pages/filters.jsx:224
#: src/pages/list.jsx:274
#: src/pages/notifications.jsx:868
#: src/pages/notifications.jsx:1082
#: src/pages/settings.jsx:76
#: src/pages/status.jsx:1268
msgid "Close"
msgstr "Fermi"

#: src/components/account-info.jsx:1810
msgid "Translated Bio"
msgstr "Tradukita biografio"

#: src/components/account-info.jsx:1904
msgid "Unable to remove from list."
msgstr "Ne eblas forigi el listo."

#: src/components/account-info.jsx:1905
msgid "Unable to add to list."
msgstr "Ne eblas aldoni al listo."

#: src/components/account-info.jsx:1924
#: src/pages/lists.jsx:104
msgid "Unable to load lists."
msgstr "Ne eblas ŝargi listojn."

#: src/components/account-info.jsx:1928
msgid "No lists."
msgstr "Ne estas listoj."

#: src/components/account-info.jsx:1939
#: src/components/list-add-edit.jsx:37
#: src/pages/lists.jsx:58
msgid "New list"
msgstr "Nova listo"

#: src/components/account-info.jsx:1997
msgid "Private note about <0>@{0}</0>"
msgstr "Personaj notoj pri <0>@{0}</0>"

#: src/components/account-info.jsx:2027
msgid "Unable to update private note."
msgstr "Ne eblas ĝisdatigi la personan noton."

#: src/components/account-info.jsx:2050
#: src/components/account-info.jsx:2220
msgid "Cancel"
msgstr "Nuligi"

#: src/components/account-info.jsx:2055
msgid "Save & close"
msgstr "Konservi kaj fermi"

#: src/components/account-info.jsx:2148
msgid "Unable to update profile."
msgstr "Ne eblas ĝisdatigi la profilon."

#: src/components/account-info.jsx:2155
#: src/components/list-add-edit.jsx:102
msgid "Name"
msgstr "Nomo"

#: src/components/account-info.jsx:2168
msgid "Bio"
msgstr "Sinprezento"

#: src/components/account-info.jsx:2181
msgid "Extra fields"
msgstr "Profilaj metadatumoj"

#: src/components/account-info.jsx:2187
msgid "Label"
msgstr "Etikedo"

#: src/components/account-info.jsx:2190
msgid "Content"
msgstr "Enhavo"

#: src/components/account-info.jsx:2223
#: src/components/list-add-edit.jsx:147
#: src/components/shortcuts-settings.jsx:715
#: src/pages/filters.jsx:554
#: src/pages/notifications.jsx:934
msgid "Save"
msgstr "Konservi"

#: src/components/account-info.jsx:2276
msgid "username"
msgstr "uzantnomo"

#: src/components/account-info.jsx:2280
msgid "server domain name"
msgstr "servila domajna nomo"

#: src/components/background-service.jsx:149
msgid "Cloak mode disabled"
msgstr "Ŝtelreĝimo estis malŝaltita"

#: src/components/background-service.jsx:149
msgid "Cloak mode enabled"
msgstr "Ŝtelreĝimo estis ŝaltita"

#: src/components/columns.jsx:19
#: src/components/nav-menu.jsx:184
#: src/components/shortcuts-settings.jsx:139
#: src/components/timeline.jsx:437
#: src/pages/catchup.jsx:876
#: src/pages/filters.jsx:89
#: src/pages/followed-hashtags.jsx:40
#: src/pages/home.jsx:53
#: src/pages/notifications.jsx:520
msgid "Home"
msgstr "Hejmo"

#: src/components/compose-button.jsx:49
#: src/compose.jsx:37
msgid "Compose"
msgstr "Redakti"

#: src/components/compose.jsx:394
msgid "You have unsaved changes. Discard this post?"
msgstr "Vi havas nekonservitajn ŝanĝojn. Ĉu forĵeti ĉi tiun afiŝon?"

#: src/components/compose.jsx:622
msgid "{0, plural, one {File {1} is not supported.} other {Files {2} are not supported.}}"
msgstr "{0, plural, one {La dosiero {1} ne estas subtenata.} other {La dosieroj {2} ne estas subtenataj.}}"

#: src/components/compose.jsx:632
#: src/components/compose.jsx:650
#: src/components/compose.jsx:1361
#: src/components/compose.jsx:1623
msgid "{maxMediaAttachments, plural, one {You can only attach up to 1 file.} other {You can only attach up to # files.}}"
msgstr "{maxMediaAttachments, plural, one {Vi povas nur kunsendi ĝis 1 dosieron.} other {Vi povas nur kunsendi ĝis # dosierojn.}}"

#: src/components/compose.jsx:799
msgid "Pop out"
msgstr "Foriri"

#: src/components/compose.jsx:806
msgid "Minimize"
msgstr "Minimumigi"

#: src/components/compose.jsx:842
msgid "Looks like you closed the parent window."
msgstr "Ŝajnas, ke vi fermis la patran fenestron."

#: src/components/compose.jsx:849
msgid "Looks like you already have a compose field open in the parent window and currently publishing. Please wait for it to be done and try again later."
msgstr "Ŝajnas, ke vi jam havas redaktan fenestron malfermita en la ĉefa fenestro kaj vi nun publikigas. Bonvolu atendi, ke ĝi estos publikigita kaj provu denove poste."

#: src/components/compose.jsx:854
msgid "Looks like you already have a compose field open in the parent window. Popping in this window will discard the changes you made in the parent window. Continue?"
msgstr "Ŝajnas, ke vi jam havas redaktan fenestron malfermitan en la ĉefa fenestro. Enirante ĉi tiun fenestron forĵetos la ŝanĝojn kiujn vi faris. Ĉu daŭrigi?"

#: src/components/compose.jsx:896
msgid "Pop in"
msgstr "Montri"

#: src/components/compose.jsx:906
msgid "Replying to @{0}’s post (<0>{1}</0>)"
msgstr "Respondante al la afiŝo de @{0} (<0>{1}</0>)"

#: src/components/compose.jsx:916
msgid "Replying to @{0}’s post"
msgstr "Respondante al la afiŝo de @{0}"

#: src/components/compose.jsx:929
msgid "Editing source post"
msgstr "Redaktante la originalan afiŝon"

#: src/components/compose.jsx:976
msgid "Poll must have at least 2 options"
msgstr "Balotenketo devas havi almenaŭ 2 eblojn"

#: src/components/compose.jsx:980
msgid "Some poll choices are empty"
msgstr "Iuj elektoj de balotado estas malplenaj"

#: src/components/compose.jsx:993
msgid "Some media have no descriptions. Continue?"
msgstr "Iuj plurmedioj ne havas priskribojn. Ĉu daŭrigi?"

#: src/components/compose.jsx:1045
msgid "Attachment #{i} failed"
msgstr "Eraro aldonante #{i}"

#: src/components/compose.jsx:1139
#: src/components/status.jsx:2029
#: src/components/timeline.jsx:984
msgid "Content warning"
msgstr "Enhavaverto"

#: src/components/compose.jsx:1155
msgid "Content warning or sensitive media"
msgstr "Enhavaverto aŭ sentema plurmedio"

#: src/components/compose.jsx:1191
#: src/components/status.jsx:93
#: src/pages/settings.jsx:304
msgid "Public"
msgstr "Publika"

#: src/components/compose.jsx:1196
#: src/components/nav-menu.jsx:386
#: src/components/shortcuts-settings.jsx:165
#: src/components/status.jsx:94
msgid "Local"
msgstr "Loka"

#: src/components/compose.jsx:1200
#: src/components/status.jsx:95
#: src/pages/settings.jsx:307
msgid "Unlisted"
msgstr "Nelistigita"

#: src/components/compose.jsx:1203
#: src/components/status.jsx:96
#: src/pages/settings.jsx:310
msgid "Followers only"
msgstr "Nur sekvantoj"

#: src/components/compose.jsx:1206
#: src/components/status.jsx:97
#: src/components/status.jsx:1907
msgid "Private mention"
msgstr "Privata mencio"

#: src/components/compose.jsx:1215
msgid "Post your reply"
msgstr "Afiŝi vian respondon"

#: src/components/compose.jsx:1217
msgid "Edit your post"
msgstr "Redakti vian afiŝon"

#: src/components/compose.jsx:1218
msgid "What are you doing?"
msgstr "Kion vi pensas?"

#: src/components/compose.jsx:1296
msgid "Mark media as sensitive"
msgstr "Aldoni averton de enhavo"

#: src/components/compose.jsx:1397
msgid "Add poll"
msgstr "Aldoni balotenketon"

#: src/components/compose.jsx:1419
msgid "Add custom emoji"
msgstr "Aldoni propran emoĝion"

#: src/components/compose.jsx:1504
#: src/components/keyboard-shortcuts-help.jsx:143
#: src/components/status.jsx:895
#: src/components/status.jsx:1683
#: src/components/status.jsx:1684
#: src/components/status.jsx:2338
msgid "Reply"
msgstr "Respondi"

#: src/components/compose.jsx:1506
msgid "Update"
msgstr "Ĝisdatigi"

#: src/components/compose.jsx:1507
msgctxt "Submit button in composer"
msgid "Post"
msgstr "Afiŝi"

#: src/components/compose.jsx:1635
msgid "Downloading GIF…"
msgstr "Elŝutante movbildon…"

#: src/components/compose.jsx:1663
msgid "Failed to download GIF"
msgstr "Malsukcesis elŝuti movbildon"

#: src/components/compose.jsx:1775
#: src/components/compose.jsx:1852
#: src/components/nav-menu.jsx:287
msgid "More…"
msgstr "Pli…"

#: src/components/compose.jsx:2257
msgid "Uploaded"
msgstr "Ĝisdatigita"

#: src/components/compose.jsx:2270
msgid "Image description"
msgstr "Priskribo de bildo"

#: src/components/compose.jsx:2271
msgid "Video description"
msgstr "Priskribo de filmeto"

#: src/components/compose.jsx:2272
msgid "Audio description"
msgstr "Priskribo de aŭdaĵo"

#: src/components/compose.jsx:2308
#: src/components/compose.jsx:2328
msgid "File size too large. Uploading might encounter issues. Try reduce the file size from {0} to {1} or lower."
msgstr "Dosiergrandeco estas tro granda. Alŝuto eble renkontos problemojn. Provu redukti la dosiergrandecon de {0} al {1} ​​aŭ malpli."

#: src/components/compose.jsx:2320
#: src/components/compose.jsx:2340
msgid "Dimension too large. Uploading might encounter issues. Try reduce dimension from {0}×{1}px to {2}×{3}px."
msgstr "Dimensio estas tro granda. Alŝuto eble renkontos problemojn. Provu redukti dimension de {0}x{1}px al {2}x{3}px."

#: src/components/compose.jsx:2348
msgid "Frame rate too high. Uploading might encounter issues."
msgstr "Bildrapido estas tro alta. Alŝuto eble renkontos problemojn."

#: src/components/compose.jsx:2408
#: src/components/compose.jsx:2658
#: src/components/shortcuts-settings.jsx:726
#: src/pages/catchup.jsx:1074
#: src/pages/filters.jsx:412
msgid "Remove"
msgstr "Forigi"

#: src/components/compose.jsx:2425
#: src/compose.jsx:83
msgid "Error"
msgstr "Eraro"

#: src/components/compose.jsx:2450
msgid "Edit image description"
msgstr "Redakti bildopriskribon"

#: src/components/compose.jsx:2451
msgid "Edit video description"
msgstr "Redakti videopriskribon"

#: src/components/compose.jsx:2452
msgid "Edit audio description"
msgstr "Redakti aŭdpriskribon"

#: src/components/compose.jsx:2497
#: src/components/compose.jsx:2546
msgid "Generating description. Please wait…"
msgstr "Kreante priskribon. Bonvolu atendi…"

#: src/components/compose.jsx:2517
msgid "Failed to generate description: {0}"
msgstr "Malsukcesis krei priskribon: {0}"

#: src/components/compose.jsx:2518
msgid "Failed to generate description"
msgstr "Malsukcesis krei priskribon"

#: src/components/compose.jsx:2530
#: src/components/compose.jsx:2536
#: src/components/compose.jsx:2582
msgid "Generate description…"
msgstr "Krei priskribon…"

#: src/components/compose.jsx:2569
msgid "Failed to generate description{0}"
msgstr "Malsukcesis krei priskribon{0}"

#: src/components/compose.jsx:2584
msgid "({0}) <0>— experimental</0>"
msgstr "({0}) <0>— eksperimenta</0>"

#: src/components/compose.jsx:2603
msgid "Done"
msgstr "Farite"

#: src/components/compose.jsx:2639
msgid "Choice {0}"
msgstr "Elekti {0}"

#: src/components/compose.jsx:2686
msgid "Multiple choices"
msgstr "Multoblaj elektoj"

#: src/components/compose.jsx:2689
msgid "Duration"
msgstr "Daŭro"

#: src/components/compose.jsx:2720
msgid "Remove poll"
msgstr "Forigi balotenketon"

#: src/components/compose.jsx:2934
msgid "Search accounts"
msgstr "Serĉi kontojn"

#: src/components/compose.jsx:2975
#: src/components/shortcuts-settings.jsx:715
#: src/pages/list.jsx:359
msgid "Add"
msgstr "Aldoni"

#: src/components/compose.jsx:2988
#: src/components/generic-accounts.jsx:227
msgid "Error loading accounts"
msgstr "Eraro dum ŝargo de kontoj"

#: src/components/compose.jsx:3131
msgid "Custom emojis"
msgstr "Propraj emoĝioj"

#: src/components/compose.jsx:3151
msgid "Search emoji"
msgstr "Serĉi emoĝion"

#: src/components/compose.jsx:3182
msgid "Error loading custom emojis"
msgstr "Eraro dum ŝarĝo de propraj emoĝioj"

#: src/components/compose.jsx:3193
msgid "Recently used"
msgstr "Ofte uzataj"

#: src/components/compose.jsx:3194
msgid "Others"
msgstr "Aliaj"

#: src/components/compose.jsx:3232
msgid "{0} more…"
msgstr "{0} pli…"

#: src/components/compose.jsx:3370
msgid "Search GIFs"
msgstr "Serĉi movbildojn"

#: src/components/compose.jsx:3385
msgid "Powered by GIPHY"
msgstr "Funkciigita de GIPHY"

#: src/components/compose.jsx:3393
msgid "Type to search GIFs"
msgstr "Tajpi por serĉi movbildojn"

#: src/components/compose.jsx:3491
#: src/components/media-modal.jsx:387
#: src/components/timeline.jsx:889
msgid "Previous"
msgstr "Antaŭa"

#: src/components/compose.jsx:3509
#: src/components/media-modal.jsx:406
#: src/components/timeline.jsx:906
msgid "Next"
msgstr "Sekva"

#: src/components/compose.jsx:3526
msgid "Error loading GIFs"
msgstr "Eraro dum ŝargo de movbildoj"

#: src/components/drafts.jsx:63
#: src/pages/settings.jsx:691
msgid "Unsent drafts"
msgstr "Nesenditaj malnetoj"

#: src/components/drafts.jsx:68
msgid "Looks like you have unsent drafts. Let's continue where you left off."
msgstr "Ŝajnas, ke vi havas nesenditajn malnetojn. Ni daŭrigu kie vi ĉesis."

#: src/components/drafts.jsx:102
msgid "Delete this draft?"
msgstr "Ĉu forigi ĉi tiun malneton?"

#: src/components/drafts.jsx:117
msgid "Error deleting draft! Please try again."
msgstr "Eraro dum forigo de malneto! Bonvolu provi denove."

#: src/components/drafts.jsx:127
#: src/components/list-add-edit.jsx:183
#: src/components/status.jsx:1318
#: src/pages/filters.jsx:587
msgid "Delete…"
msgstr "Forigi…"

#: src/components/drafts.jsx:146
msgid "Error fetching reply-to status!"
msgstr "Eraro ricevi respondan staton!"

#: src/components/drafts.jsx:171
msgid "Delete all drafts?"
msgstr "Ĉu forigi ĉiujn malnetojn?"

#: src/components/drafts.jsx:189
msgid "Error deleting drafts! Please try again."
msgstr "Eraro dum forigo de malnetoj! Bonvolu provi denove."

#: src/components/drafts.jsx:201
msgid "Delete all…"
msgstr "Forigi ĉiujn…"

#: src/components/drafts.jsx:209
msgid "No drafts found."
msgstr "Neniuj malnetoj trovitaj."

#: src/components/drafts.jsx:245
#: src/pages/catchup.jsx:1928
msgid "Poll"
msgstr "Balotenketo"

#: src/components/drafts.jsx:248
#: src/pages/account-statuses.jsx:365
msgid "Media"
msgstr "Plurmedio"

#: src/components/embed-modal.jsx:22
msgid "Open in new window"
msgstr "Malfermi en nova fenestro"

#: src/components/follow-request-buttons.jsx:42
#: src/pages/notifications.jsx:918
msgid "Accept"
msgstr "Akcepti"

#: src/components/follow-request-buttons.jsx:68
msgid "Reject"
msgstr "Malakcepti"

#: src/components/follow-request-buttons.jsx:75
#: src/pages/notifications.jsx:1201
msgid "Accepted"
msgstr "Akceptita"

#: src/components/follow-request-buttons.jsx:79
msgid "Rejected"
msgstr "Malakceptita"

#: src/components/generic-accounts.jsx:24
msgid "Nothing to show"
msgstr "Nenio por montri"

#: src/components/generic-accounts.jsx:145
#: src/components/notification.jsx:438
#: src/pages/accounts.jsx:41
#: src/pages/search.jsx:227
#: src/pages/search.jsx:260
msgid "Accounts"
msgstr "Kontoj"

#: src/components/generic-accounts.jsx:205
#: src/components/timeline.jsx:519
#: src/pages/list.jsx:293
#: src/pages/notifications.jsx:848
#: src/pages/search.jsx:454
#: src/pages/status.jsx:1301
msgid "Show more…"
msgstr "Montri pli…"

#: src/components/generic-accounts.jsx:210
#: src/components/timeline.jsx:524
#: src/pages/search.jsx:459
msgid "The end."
msgstr "La fino."

#: src/components/keyboard-shortcuts-help.jsx:43
#: src/components/nav-menu.jsx:405
#: src/pages/catchup.jsx:1619
msgid "Keyboard shortcuts"
msgstr "Fulmoklavoj"

#: src/components/keyboard-shortcuts-help.jsx:51
msgid "Keyboard shortcuts help"
msgstr "Helpo por fulmoklavoj"

#: src/components/keyboard-shortcuts-help.jsx:55
#: src/pages/catchup.jsx:1644
msgid "Next post"
msgstr "Sekva afiŝo"

#: src/components/keyboard-shortcuts-help.jsx:59
#: src/pages/catchup.jsx:1652
msgid "Previous post"
msgstr "Antaŭa afiŝo"

#: src/components/keyboard-shortcuts-help.jsx:63
msgid "Skip carousel to next post"
msgstr "Salti karuselon al la sekva afiŝo"

#: src/components/keyboard-shortcuts-help.jsx:65
msgid "<0>Shift</0> + <1>j</1>"
msgstr "<0>Ŝovo</0> + <1>j</1>"

#: src/components/keyboard-shortcuts-help.jsx:71
msgid "Skip carousel to previous post"
msgstr "Salti karuselon al la antaŭa afiŝo"

#: src/components/keyboard-shortcuts-help.jsx:73
msgid "<0>Shift</0> + <1>k</1>"
msgstr "<0>Ŝovo</0> + <1>k</1>"

#: src/components/keyboard-shortcuts-help.jsx:79
msgid "Load new posts"
msgstr "Ŝargi novajn afiŝojn"

#: src/components/keyboard-shortcuts-help.jsx:83
#: src/pages/catchup.jsx:1676
msgid "Open post details"
msgstr "Malfermi detalojn pri afiŝo"

#: src/components/keyboard-shortcuts-help.jsx:85
msgid "<0>Enter</0> or <1>o</1>"
msgstr "<0>Enen-klavo</0> aŭ <1>o</1>"

#: src/components/keyboard-shortcuts-help.jsx:92
msgid "Expand content warning or<0/>toggle expanded/collapsed thread"
msgstr "Vastigi enhavaverton aŭ<0/>ŝalti vastigitan/kolapsitan fadenon"

#: src/components/keyboard-shortcuts-help.jsx:101
msgid "Close post or dialogs"
msgstr "Fermi afiŝon aŭ dialogojn"

#: src/components/keyboard-shortcuts-help.jsx:103
msgid "<0>Esc</0> or <1>Backspace</1>"
msgstr "<0>Esc-klavo</0> aŭ <1>Retropaŝo</1>"

#: src/components/keyboard-shortcuts-help.jsx:109
msgid "Focus column in multi-column mode"
msgstr "Fokuso-kolumno en plurkolumna reĝimo"

#: src/components/keyboard-shortcuts-help.jsx:111
msgid "<0>1</0> to <1>9</1>"
msgstr "<0>1</0> ĝis <1>9</1>"

#: src/components/keyboard-shortcuts-help.jsx:117
msgid "Compose new post"
msgstr "Redakti novan afiŝon"

#: src/components/keyboard-shortcuts-help.jsx:121
msgid "Compose new post (new window)"
msgstr "Redakti novan afiŝon (nova fenestro)"

#: src/components/keyboard-shortcuts-help.jsx:124
msgid "<0>Shift</0> + <1>c</1>"
msgstr "<0>Ŝovo</0> + <1>c</1>"

#: src/components/keyboard-shortcuts-help.jsx:130
msgid "Send post"
msgstr "Sendi afiŝon"

#: src/components/keyboard-shortcuts-help.jsx:132
msgid "<0>Ctrl</0> + <1>Enter</1> or <2>⌘</2> + <3>Enter</3>"
msgstr "<0>Stirklavo</0> + <1>Enen-klavo</1> aŭ <2>⌘</2> + <3>Enen-klavo</3>"

#: src/components/keyboard-shortcuts-help.jsx:139
#: src/components/nav-menu.jsx:374
#: src/components/search-form.jsx:72
#: src/components/shortcuts-settings.jsx:52
#: src/components/shortcuts-settings.jsx:179
#: src/pages/search.jsx:39
#: src/pages/search.jsx:209
msgid "Search"
msgstr "Serĉi"

#: src/components/keyboard-shortcuts-help.jsx:147
msgid "Reply (new window)"
msgstr "Respondi (nova fenestro)"

#: src/components/keyboard-shortcuts-help.jsx:150
msgid "<0>Shift</0> + <1>r</1>"
msgstr "<0>Ŝovo</0> + <1>r</1>"

#: src/components/keyboard-shortcuts-help.jsx:156
msgid "Like (favourite)"
msgstr "Ŝati (Stemulo)"

#: src/components/keyboard-shortcuts-help.jsx:158
msgid "<0>l</0> or <1>f</1>"
msgstr "<0>l</0> aŭ <1>f</1>"

#: src/components/keyboard-shortcuts-help.jsx:164
#: src/components/status.jsx:903
#: src/components/status.jsx:2364
#: src/components/status.jsx:2396
#: src/components/status.jsx:2397
msgid "Boost"
msgstr "Diskonigi"

#: src/components/keyboard-shortcuts-help.jsx:166
msgid "<0>Shift</0> + <1>b</1>"
msgstr "<0>Ŝovo</0> + <1>b</1>"

#: src/components/keyboard-shortcuts-help.jsx:172
#: src/components/status.jsx:988
#: src/components/status.jsx:2421
#: src/components/status.jsx:2422
msgid "Bookmark"
msgstr "Legosigni"

#: src/components/keyboard-shortcuts-help.jsx:176
msgid "Toggle Cloak mode"
msgstr "Baskuligi la ŝtelreĝimon"

#: src/components/keyboard-shortcuts-help.jsx:178
msgid "<0>Shift</0> + <1>Alt</1> + <2>k</2>"
msgstr "<0>Ŝovo</0> + <1>Alt-klavo</1> + <2>k</2>"

#: src/components/list-add-edit.jsx:37
msgid "Edit list"
msgstr "Redakti liston"

#: src/components/list-add-edit.jsx:93
msgid "Unable to edit list."
msgstr "Ne eblas redakti liston."

#: src/components/list-add-edit.jsx:94
msgid "Unable to create list."
msgstr "Ne eblas krei liston."

#: src/components/list-add-edit.jsx:122
msgid "Show replies to list members"
msgstr "Montri respondoj al listmembroj"

#: src/components/list-add-edit.jsx:125
msgid "Show replies to people I follow"
msgstr "Montri respondojn al homoj, kiujn mi sekvas"

#: src/components/list-add-edit.jsx:128
msgid "Don't show replies"
msgstr "Ne montri respondojn"

#: src/components/list-add-edit.jsx:141
msgid "Hide posts on this list from Home/Following"
msgstr "Kaŝi afiŝojn en ĉi tiu listo de Hejmo/Sekvatoj"

#: src/components/list-add-edit.jsx:147
#: src/pages/filters.jsx:554
msgid "Create"
msgstr "Krei"

#: src/components/list-add-edit.jsx:154
msgid "Delete this list?"
msgstr "Ĉu forigi ĉi tiun liston?"

#: src/components/list-add-edit.jsx:173
msgid "Unable to delete list."
msgstr "Ne eblas forigi liston."

#: src/components/media-alt-modal.jsx:38
#: src/components/media.jsx:50
msgid "Media description"
msgstr "Priskribo de plurmedio"

#: src/components/media-alt-modal.jsx:57
#: src/components/status.jsx:1032
#: src/components/status.jsx:1059
#: src/components/translation-block.jsx:195
msgid "Translate"
msgstr "Traduki"

#: src/components/media-alt-modal.jsx:68
#: src/components/status.jsx:1046
#: src/components/status.jsx:1073
msgid "Speak"
msgstr "Paroli"

#: src/components/media-modal.jsx:294
msgid "Open original media in new window"
msgstr "Malfermi originalan plurmedion en nova fenestro"

#: src/components/media-modal.jsx:298
msgid "Open original media"
msgstr "Malfermi originalan plurmedion"

#: src/components/media-modal.jsx:314
msgid "Attempting to describe image. Please wait…"
msgstr "Provante priskribi bildon. Bonvolu atendi…"

#: src/components/media-modal.jsx:329
msgid "Failed to describe image"
msgstr "Malsukcesis priskribi la bildon"

#: src/components/media-modal.jsx:339
msgid "Describe image…"
msgstr "Priskribi la bildon…"

#: src/components/media-modal.jsx:362
msgid "View post"
msgstr "Vidi afiŝon"

#: src/components/media-post.jsx:127
msgid "Sensitive media"
msgstr "Sentema plurmedio"

#: src/components/media-post.jsx:132
msgid "Filtered: {filterTitleStr}"
msgstr "Filtrila: {filterTitleStr}"

#: src/components/media-post.jsx:133
#: src/components/status.jsx:3511
#: src/components/status.jsx:3607
#: src/components/status.jsx:3685
#: src/components/timeline.jsx:973
#: src/pages/catchup.jsx:75
#: src/pages/catchup.jsx:1876
msgid "Filtered"
msgstr "Filtrila"

#: src/components/modals.jsx:72
msgid "Post published. Check it out."
msgstr "Afiŝo publikigita. Rigardu."

#: src/components/modals.jsx:73
msgid "Reply posted. Check it out."
msgstr "Respondo publikigita. Rigardu."

#: src/components/modals.jsx:74
msgid "Post updated. Check it out."
msgstr "Afiŝo ĝisdatigita. Rigardu."

#: src/components/nav-menu.jsx:126
msgid "Menu"
msgstr "Menuo"

#: src/components/nav-menu.jsx:162
msgid "Reload page now to update?"
msgstr "Ĉu reŝargi la paĝon nun por ĝisdatigi?"

#: src/components/nav-menu.jsx:174
msgid "New update available…"
msgstr "Nova ĝisdatigo disponebla…"

#. js-lingui-explicit-id
#: src/components/nav-menu.jsx:193
#: src/components/shortcuts-settings.jsx:140
#: src/pages/following.jsx:22
#: src/pages/following.jsx:141
msgid "following.title"
msgstr "Sekvatoj"

#: src/components/nav-menu.jsx:200
#: src/pages/catchup.jsx:871
msgid "Catch-up"
msgstr "Aktualiĝi"

#: src/components/nav-menu.jsx:207
#: src/components/shortcuts-settings.jsx:58
#: src/components/shortcuts-settings.jsx:146
#: src/pages/home.jsx:224
#: src/pages/mentions.jsx:20
#: src/pages/mentions.jsx:167
#: src/pages/settings.jsx:1102
#: src/pages/trending.jsx:381
msgid "Mentions"
msgstr "Mencioj"

#: src/components/nav-menu.jsx:214
#: src/components/shortcuts-settings.jsx:49
#: src/components/shortcuts-settings.jsx:152
#: src/pages/filters.jsx:24
#: src/pages/home.jsx:84
#: src/pages/home.jsx:184
#: src/pages/notifications.jsx:112
#: src/pages/notifications.jsx:524
msgid "Notifications"
msgstr "Sciigoj"

#: src/components/nav-menu.jsx:217
msgid "New"
msgstr "Nova"

#: src/components/nav-menu.jsx:228
msgid "Profile"
msgstr "Profilo"

#: src/components/nav-menu.jsx:241
#: src/components/nav-menu.jsx:268
#: src/components/shortcuts-settings.jsx:50
#: src/components/shortcuts-settings.jsx:158
#: src/pages/list.jsx:126
#: src/pages/lists.jsx:16
#: src/pages/lists.jsx:50
msgid "Lists"
msgstr "Listoj"

#: src/components/nav-menu.jsx:249
#: src/components/shortcuts.jsx:209
#: src/pages/list.jsx:133
msgid "All Lists"
msgstr "Ĉiuj listoj"

#: src/components/nav-menu.jsx:276
#: src/components/shortcuts-settings.jsx:54
#: src/components/shortcuts-settings.jsx:195
#: src/pages/bookmarks.jsx:11
#: src/pages/bookmarks.jsx:23
msgid "Bookmarks"
msgstr "Legosignoj"

#: src/components/nav-menu.jsx:296
#: src/components/shortcuts-settings.jsx:55
#: src/components/shortcuts-settings.jsx:201
#: src/pages/catchup.jsx:1446
#: src/pages/catchup.jsx:2062
#: src/pages/favourites.jsx:11
#: src/pages/favourites.jsx:23
#: src/pages/settings.jsx:1106
msgid "Likes"
msgstr "Stemuloj"

#: src/components/nav-menu.jsx:302
#: src/pages/followed-hashtags.jsx:14
#: src/pages/followed-hashtags.jsx:44
msgid "Followed Hashtags"
msgstr "Sekvataj kradvortoj"

#: src/components/nav-menu.jsx:310
#: src/pages/account-statuses.jsx:331
#: src/pages/filters.jsx:54
#: src/pages/filters.jsx:93
#: src/pages/hashtag.jsx:339
msgid "Filters"
msgstr "Filtriloj"

#: src/components/nav-menu.jsx:318
msgid "Muted users"
msgstr "Silentigitaj uzantoj"

#: src/components/nav-menu.jsx:326
msgid "Muted users…"
msgstr "Silentigitaj uzantoj…"

#: src/components/nav-menu.jsx:333
msgid "Blocked users"
msgstr "Blokitaj uzantoj"

#: src/components/nav-menu.jsx:341
msgid "Blocked users…"
msgstr "Blokitaj uzantoj…"

#: src/components/nav-menu.jsx:353
msgid "Accounts…"
msgstr "Kontoj…"

#: src/components/nav-menu.jsx:363
#: src/pages/login.jsx:189
#: src/pages/status.jsx:804
#: src/pages/welcome.jsx:64
msgid "Log in"
msgstr "Ensaluti"

#: src/components/nav-menu.jsx:380
#: src/components/shortcuts-settings.jsx:57
#: src/components/shortcuts-settings.jsx:172
#: src/pages/trending.jsx:441
msgid "Trending"
msgstr "Populara"

#: src/components/nav-menu.jsx:392
#: src/components/shortcuts-settings.jsx:165
msgid "Federated"
msgstr "Fratara"

#: src/components/nav-menu.jsx:415
msgid "Shortcuts / Columns…"
msgstr "Ŝparvojoj / Kolumnoj…"

#: src/components/nav-menu.jsx:425
#: src/components/nav-menu.jsx:439
msgid "Settings…"
msgstr "Agordoj…"

#: src/components/notification-service.jsx:160
msgid "Notification"
msgstr "Sciigo"

#: src/components/notification-service.jsx:166
msgid "This notification is from your other account."
msgstr "Ĉi tiu sciigo estas de via alia konto."

#: src/components/notification-service.jsx:195
msgid "View all notifications"
msgstr "Vidi ĉiujn sciigojn"

#: src/components/notification.jsx:70
msgid "{account} reacted to your post with {emojiObject}"
msgstr "{account} reagis al via afiŝo kun {emojiObject}"

#: src/components/notification.jsx:77
msgid "{account} published a post."
msgstr "{account} publikigis afiŝon."

#: src/components/notification.jsx:85
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted your reply.} other {{account} boosted your post.}}} other {{account} boosted {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted your reply.} other {<2><3>{1}</3> people</2> boosted your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} diskonigis vian respondon.} other {{account} diskonigis vian afiŝon.}}} other {{account} diskonigis {postsCount} de viaj afiŝoj.}}} other {{postType, select, reply {<0><1>{0}</1> homoj</0> diskonigis vian respondon.} other {<2><3>{1}</3> homoj</2> diskonigis vian afiŝon.}}}}"

#: src/components/notification.jsx:128
msgid "{count, plural, =1 {{account} followed you.} other {<0><1>{0}</1> people</0> followed you.}}"
msgstr "{count, plural, =1 {{account} sekvis vin.} other {<0><1>{0}</1> homoj</0> sekvis vin.}}"

#: src/components/notification.jsx:142
msgid "{account} requested to follow you."
msgstr "{account} petis sekvi vin."

#: src/components/notification.jsx:151
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} liked your reply.} other {{account} liked your post.}}} other {{account} liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> liked your reply.} other {<2><3>{1}</3> people</2> liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} ŝatis vian respondon.} other {{account} ŝatis vian afiŝon.}}} other {{account} ŝatis {postsCount} de viaj afiŝoj.}}} other {{postType, select, reply {<0><1>{0}</1> homoj</0> ŝatis vian respondon.} other {<2><3>{1}</3> homoj</2> ŝatis vian afiŝon.}}}}"

#: src/components/notification.jsx:193
msgid "A poll you have voted in or created has ended."
msgstr "Balotenketo, kiun vi voĉdonis aŭ kreis, finiĝis."

#: src/components/notification.jsx:194
msgid "A poll you have created has ended."
msgstr "Balotenketo, kiun vi kreis, finiĝis."

#: src/components/notification.jsx:195
msgid "A poll you have voted in has ended."
msgstr "Balotenketo, pri kiu vi voĉdonis, finiĝis."

#: src/components/notification.jsx:196
msgid "A post you interacted with has been edited."
msgstr "Afiŝo, kun kiu vi interagis, estis redaktita."

#: src/components/notification.jsx:204
msgid "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} boosted & liked your reply.} other {{account} boosted & liked your post.}}} other {{account} boosted & liked {postsCount} of your posts.}}} other {{postType, select, reply {<0><1>{0}</1> people</0> boosted & liked your reply.} other {<2><3>{1}</3> people</2> boosted & liked your post.}}}}"
msgstr "{count, plural, =1 {{postsCount, plural, =1 {{postType, select, reply {{account} diskonigis kaj ŝatis vian respondon.} other {{account} diskonigis kaj ŝatis vian afiŝon.}}} other {{account} diskonigis kaj ŝatis {postsCount} de viaj afiŝoj.}}} other {{postType, select, reply {<0><1>{0}</1> homoj</0> diskonigis kaj ŝatis vian respondon.} other {<2><3>{1}</3> homoj</2> diskonigis kaj ŝatis vian afiŝon.}}}}"

#: src/components/notification.jsx:246
msgid "{account} signed up."
msgstr "{account} aliĝis."

#: src/components/notification.jsx:248
msgid "{account} reported {targetAccount}"
msgstr "{account} raportis {targetAccount}"

#: src/components/notification.jsx:253
msgid "Lost connections with <0>{name}</0>."
msgstr "Perditaj konektoj kun <0>{name}</0>."

#: src/components/notification.jsx:259
msgid "Moderation warning"
msgstr "Moderiga averto"

#: src/components/notification.jsx:269
msgid "An admin from <0>{from}</0> has suspended <1>{targetName}</1>, which means you can no longer receive updates from them or interact with them."
msgstr "Administranto de <0>{from}</0> malakceptis <1>{targetName}</1>, kio signifas, ke vi ne plu povas ricevi ĝisdatigojn de ili aŭ interagi kun ili."

#: src/components/notification.jsx:275
msgid "An admin from <0>{from}</0> has blocked <1>{targetName}</1>. Affected followers: {followersCount}, followings: {followingCount}."
msgstr "Administranto de <0>{from}</0> blokis <1>{targetName}</1>. Afektitaj sekvantoj: {followersCount}, Sekvantoj: {followingCount}."

#: src/components/notification.jsx:281
msgid "You have blocked <0>{targetName}</0>. Removed followers: {followersCount}, followings: {followingCount}."
msgstr "Vi blokis <0>{targetName}</0>. Forigitaj sekvantoj: {followersCount}, sekvantoj: {followingCount}."

#: src/components/notification.jsx:289
msgid "Your account has received a moderation warning."
msgstr "Via konto ricevis moderan averton."

#: src/components/notification.jsx:290
msgid "Your account has been disabled."
msgstr "Via konto estas malŝaltita."

#: src/components/notification.jsx:291
msgid "Some of your posts have been marked as sensitive."
msgstr "Kelkaj el viaj afiŝoj estis markitaj kiel sentemaj."

#: src/components/notification.jsx:292
msgid "Some of your posts have been deleted."
msgstr "Kelkaj el viaj afiŝoj estis forigitaj."

#: src/components/notification.jsx:293
msgid "Your posts will be marked as sensitive from now on."
msgstr "Viaj afiŝoj estos markitaj kiel sentemaj ekde nun."

#: src/components/notification.jsx:294
msgid "Your account has been limited."
msgstr "Via konto estis limigita."

#: src/components/notification.jsx:295
msgid "Your account has been suspended."
msgstr "Via konto estas malakceptita."

#: src/components/notification.jsx:369
msgid "[Unknown notification type: {type}]"
msgstr "[Nekonata tipo de sciigo: {type}]"

#: src/components/notification.jsx:434
#: src/components/status.jsx:1002
#: src/components/status.jsx:1012
msgid "Boosted/Liked by…"
msgstr "Diskonigita/Ŝatita de…"

#: src/components/notification.jsx:435
msgid "Liked by…"
msgstr "Ŝatita de…"

#: src/components/notification.jsx:436
msgid "Boosted by…"
msgstr "Diskonigita de…"

#: src/components/notification.jsx:437
msgid "Followed by…"
msgstr "Sekvita de…"

#: src/components/notification.jsx:508
#: src/components/notification.jsx:524
msgid "Learn more <0/>"
msgstr "Lerni pli <0/>"

#: src/components/notification.jsx:756
#: src/components/status.jsx:211
msgid "Read more →"
msgstr "Legi pli →"

#: src/components/poll.jsx:110
msgid "Voted"
msgstr "Voĉdonite"

#: src/components/poll.jsx:116
msgid "{optionVotesCount, plural, one {# vote} other {# votes}}"
msgstr "{optionVotesCount, plural, one {# voĉdono} other {# voĉdonoj}}"

#: src/components/poll.jsx:136
#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Hide results"
msgstr "Kaŝi rezultojn"

#: src/components/poll.jsx:185
msgid "Vote"
msgstr "Voĉdoni"

#: src/components/poll.jsx:205
#: src/components/poll.jsx:207
#: src/pages/status.jsx:1170
#: src/pages/status.jsx:1193
msgid "Refresh"
msgstr "Aktualigi"

#: src/components/poll.jsx:219
#: src/components/poll.jsx:223
msgid "Show results"
msgstr "Montri rezultojn"

#: src/components/poll.jsx:228
msgid "{votesCount, plural, one {<0>{0}</0> vote} other {<1>{1}</1> votes}}"
msgstr "{votesCount, plural, one {<0>{0}</0> voĉdono} other {<1>{1}</1> voĉdonoj}}"

#: src/components/poll.jsx:245
msgid "{votersCount, plural, one {<0>{0}</0> voter} other {<1>{1}</1> voters}}"
msgstr "{votersCount, plural, one {<0>{0}</0> voĉdonanto} other {<1>{1}</1> voĉdonantoj}}"

#: src/components/poll.jsx:265
msgid "Ended <0/>"
msgstr "Finita <0/>"

#: src/components/poll.jsx:269
msgid "Ended"
msgstr "Finita"

#: src/components/poll.jsx:272
msgid "Ending <0/>"
msgstr "Finante <0/>"

#: src/components/poll.jsx:276
msgid "Ending"
msgstr "Finante"

#. Relative time in seconds, as short as possible
#: src/components/relative-time.jsx:57
msgid "{0}s"
msgstr "{0}s"

#. Relative time in minutes, as short as possible
#: src/components/relative-time.jsx:62
msgid "{0}m"
msgstr "{0}m"

#. Relative time in hours, as short as possible
#: src/components/relative-time.jsx:67
msgid "{0}h"
msgstr "{0}h"

#: src/components/report-modal.jsx:29
msgid "Spam"
msgstr "Trudaĵo"

#: src/components/report-modal.jsx:30
msgid "Malicious links, fake engagement, or repetitive replies"
msgstr "Trompaj ligiloj, falsa engaĝiĝo aŭ ripetaj respondoj"

#: src/components/report-modal.jsx:33
msgid "Illegal"
msgstr "Kontraŭleĝa"

#: src/components/report-modal.jsx:34
msgid "Violates the law of your or the server's country"
msgstr "Malobservas la leĝon de via aŭ de la servilo lando"

#: src/components/report-modal.jsx:37
msgid "Server rule violation"
msgstr "Malobservo de servila regulo"

#: src/components/report-modal.jsx:38
msgid "Breaks specific server rules"
msgstr "Malobservas specifajn servilajn regulojn"

#: src/components/report-modal.jsx:39
msgid "Violation"
msgstr "Malobservo"

#: src/components/report-modal.jsx:42
msgid "Other"
msgstr "Alia"

#: src/components/report-modal.jsx:43
msgid "Issue doesn't fit other categories"
msgstr "La problemo ne taŭgas en aliaj kategorioj"

#: src/components/report-modal.jsx:68
msgid "Report Post"
msgstr "Raporti afiŝon"

#: src/components/report-modal.jsx:68
msgid "Report @{username}"
msgstr "Raporti @{username}"

#: src/components/report-modal.jsx:104
msgid "Pending review"
msgstr "Atendante revizion"

#: src/components/report-modal.jsx:146
msgid "Post reported"
msgstr "Afiŝo raportita"

#: src/components/report-modal.jsx:146
msgid "Profile reported"
msgstr "Raportita profilo"

#: src/components/report-modal.jsx:154
msgid "Unable to report post"
msgstr "Ne eblas raporti afiŝon"

#: src/components/report-modal.jsx:155
msgid "Unable to report profile"
msgstr "Ne eblas raporti profilon"

#: src/components/report-modal.jsx:163
msgid "What's the issue with this post?"
msgstr "Kio estas la problema kun ĉi tiu afiŝo?"

#: src/components/report-modal.jsx:164
msgid "What's the issue with this profile?"
msgstr "Kio estas la problemo kun ĉi tiu profilo?"

#: src/components/report-modal.jsx:233
msgid "Additional info"
msgstr "Pliaj informoj"

#: src/components/report-modal.jsx:256
msgid "Forward to <0>{domain}</0>"
msgstr "Sendi al <0>{domain}</0>"

#: src/components/report-modal.jsx:266
msgid "Send Report"
msgstr "Sendi Raporton"

#: src/components/report-modal.jsx:275
msgid "Muted {username}"
msgstr "Silentigita {username}"

#: src/components/report-modal.jsx:278
msgid "Unable to mute {username}"
msgstr "Ne eblas silentigi {username}"

#: src/components/report-modal.jsx:283
msgid "Send Report <0>+ Mute profile</0>"
msgstr "Sendi raporton <0>+ Silentigi profilon</0>"

#: src/components/report-modal.jsx:294
msgid "Blocked {username}"
msgstr "Blokita {username}"

#: src/components/report-modal.jsx:297
msgid "Unable to block {username}"
msgstr "Ne eblas bloki {username}"

#: src/components/report-modal.jsx:302
msgid "Send Report <0>+ Block profile</0>"
msgstr "Sendi raporton <0>+ Bloki profilon</0>"

#: src/components/search-form.jsx:202
msgid "{query} <0>‒ accounts, hashtags & posts</0>"
msgstr "{query} <0>‒ kontoj, kradvortoj kaj afiŝoj</0>"

#: src/components/search-form.jsx:215
msgid "Posts with <0>{query}</0>"
msgstr "Afiŝoj kun <0>{query}</0>"

#: src/components/search-form.jsx:227
msgid "Posts tagged with <0>#{0}</0>"
msgstr "Afiŝoj etikeditaj kun <0>#{0}</0>"

#: src/components/search-form.jsx:241
msgid "Look up <0>{query}</0>"
msgstr "Serĉi <0>{query}</0>"

#: src/components/search-form.jsx:252
msgid "Accounts with <0>{query}</0>"
msgstr "Kontoj kun <0>{query}</0>"

#: src/components/shortcuts-settings.jsx:48
msgid "Home / Following"
msgstr "Hejmo / Sekvatoj"

#: src/components/shortcuts-settings.jsx:51
msgid "Public (Local / Federated)"
msgstr "Publika (Loka / Fratara)"

#: src/components/shortcuts-settings.jsx:53
msgid "Account"
msgstr "Konto"

#: src/components/shortcuts-settings.jsx:56
msgid "Hashtag"
msgstr "Kradvorto"

#: src/components/shortcuts-settings.jsx:63
msgid "List ID"
msgstr "Listo ID"

#: src/components/shortcuts-settings.jsx:70
msgid "Local only"
msgstr "Nur loka"

#: src/components/shortcuts-settings.jsx:75
#: src/components/shortcuts-settings.jsx:84
#: src/components/shortcuts-settings.jsx:122
#: src/pages/login.jsx:193
msgid "Instance"
msgstr "Nodo"

#: src/components/shortcuts-settings.jsx:78
#: src/components/shortcuts-settings.jsx:87
#: src/components/shortcuts-settings.jsx:125
msgid "Optional, e.g. mastodon.social"
msgstr "Nedeviga, ekz. mastodon.social"

#: src/components/shortcuts-settings.jsx:93
msgid "Search term"
msgstr "Serĉi terminon"

#: src/components/shortcuts-settings.jsx:96
msgid "Optional, unless for multi-column mode"
msgstr "Nedeviga, krom se por plurkolumna reĝimo"

#: src/components/shortcuts-settings.jsx:113
msgid "e.g. PixelArt (Max 5, space-separated)"
msgstr "ekz. PixelArt (Maksimumo 5, spac-separata)"

#: src/components/shortcuts-settings.jsx:117
#: src/pages/hashtag.jsx:355
msgid "Media only"
msgstr "Nur plurmedio"

#: src/components/shortcuts-settings.jsx:235
#: src/components/shortcuts.jsx:186
msgid "Shortcuts"
msgstr "Ŝparvojoj"

#: src/components/shortcuts-settings.jsx:243
msgid "beta"
msgstr "beta"

#: src/components/shortcuts-settings.jsx:249
msgid "Specify a list of shortcuts that'll appear as:"
msgstr "Indiki liston de ŝparvojoj, kiuj aperos kiel:"

#: src/components/shortcuts-settings.jsx:255
msgid "Floating button"
msgstr "Flosanta butono"

#: src/components/shortcuts-settings.jsx:260
msgid "Tab/Menu bar"
msgstr "Langetaro/Menubreto"

#: src/components/shortcuts-settings.jsx:265
msgid "Multi-column"
msgstr "Plurkolumno"

#: src/components/shortcuts-settings.jsx:332
msgid "Not available in current view mode"
msgstr "Ne disponebla en nuna vidoreĝimo"

#: src/components/shortcuts-settings.jsx:351
msgid "Move up"
msgstr "Moviĝi supren"

#: src/components/shortcuts-settings.jsx:367
msgid "Move down"
msgstr "Moviĝi malsupren"

#: src/components/shortcuts-settings.jsx:379
#: src/components/status.jsx:1280
#: src/pages/list.jsx:170
msgid "Edit"
msgstr "Redakti"

#: src/components/shortcuts-settings.jsx:400
msgid "Add more than one shortcut/column to make this work."
msgstr "Aldoni pli ol unu ŝparvojon/kolumnon por ke ĉi tio funkciu."

#: src/components/shortcuts-settings.jsx:411
msgid "No columns yet. Tap on the Add column button."
msgstr "Ankoraŭ neniuj kolumnoj. Alklaku la butonon Aldoni kolumnon."

#: src/components/shortcuts-settings.jsx:412
msgid "No shortcuts yet. Tap on the Add shortcut button."
msgstr "Ankoraŭ neniuj ŝparvojoj. Alklaku la butonon Aldoni ŝparvojon."

#: src/components/shortcuts-settings.jsx:415
msgid "Not sure what to add?<0/>Try adding <1>Home / Following and Notifications</1> first."
msgstr "Ĉu vi ne certas, kion aldoni? <0/>Provu unue aldoni <1>Hejmo / Sekvatoj kaj Sciigoj</1>."

#: src/components/shortcuts-settings.jsx:443
msgid "Max {SHORTCUTS_LIMIT} columns"
msgstr "Maks. {SHORTCUTS_LIMIT} kolumnoj"

#: src/components/shortcuts-settings.jsx:444
msgid "Max {SHORTCUTS_LIMIT} shortcuts"
msgstr "Maks. {SHORTCUTS_LIMIT} ŝparvojoj"

#: src/components/shortcuts-settings.jsx:458
msgid "Import/export"
msgstr "Importi/eksporti"

#: src/components/shortcuts-settings.jsx:468
msgid "Add column…"
msgstr "Aldoni kolumnon…"

#: src/components/shortcuts-settings.jsx:469
msgid "Add shortcut…"
msgstr "Aldoni ŝparvojon…"

#: src/components/shortcuts-settings.jsx:516
msgid "Specific list is optional. For multi-column mode, list is required, else the column will not be shown."
msgstr "Specifa listo estas laŭvola. Por plurkolumna reĝimo, listo estas postulata, alie la kolumno ne estos montrata."

#: src/components/shortcuts-settings.jsx:517
msgid "For multi-column mode, search term is required, else the column will not be shown."
msgstr "Por plurkolumna reĝimo, serĉtermino estas postulata, alie la kolumno ne estos montrata."

#: src/components/shortcuts-settings.jsx:518
msgid "Multiple hashtags are supported. Space-separated."
msgstr "Plurkradvortoj estas subtenataj. Spac-separataj."

#: src/components/shortcuts-settings.jsx:587
msgid "Edit shortcut"
msgstr "Redakti ŝparvojon"

#: src/components/shortcuts-settings.jsx:587
msgid "Add shortcut"
msgstr "Aldoni ŝparvojon"

#: src/components/shortcuts-settings.jsx:623
msgid "Timeline"
msgstr "Templinio"

#: src/components/shortcuts-settings.jsx:649
msgid "List"
msgstr "Listo"

#: src/components/shortcuts-settings.jsx:788
msgid "Import/Export <0>Shortcuts</0>"
msgstr "Importi/eksporti <0>Ŝparvojoj</0>"

#: src/components/shortcuts-settings.jsx:798
msgid "Import"
msgstr "Importi"

#: src/components/shortcuts-settings.jsx:806
msgid "Paste shortcuts here"
msgstr "Alglui ŝparvojojn ĉi tie"

#: src/components/shortcuts-settings.jsx:822
msgid "Downloading saved shortcuts from instance server…"
msgstr "Elŝutante konservitajn ŝparvojojn de nodservilo…"

#: src/components/shortcuts-settings.jsx:851
msgid "Unable to download shortcuts"
msgstr "Ne eblas elŝuti ŝparvojojn"

#: src/components/shortcuts-settings.jsx:854
msgid "Download shortcuts from instance server"
msgstr "Elŝuti ŝparvojojn de nodservilo"

#: src/components/shortcuts-settings.jsx:912
msgid "* Exists in current shortcuts"
msgstr "* Ekzistas en nunaj ŝparvojoj"

#: src/components/shortcuts-settings.jsx:917
msgid "List may not work if it's from a different account."
msgstr "Listo eble ne funkcias se ĝi venas de malsama konto."

#: src/components/shortcuts-settings.jsx:927
msgid "Invalid settings format"
msgstr "Nevalida agorda formato"

#: src/components/shortcuts-settings.jsx:935
msgid "Append to current shortcuts?"
msgstr "Ĉu aldoni al nunaj ŝparvojoj?"

#: src/components/shortcuts-settings.jsx:938
msgid "Only shortcuts that don’t exist in current shortcuts will be appended."
msgstr "Nur ŝparvojoj kiuj ne ekzistas en la nunaj ŝparvojoj estos aldonitaj."

#: src/components/shortcuts-settings.jsx:960
msgid "No new shortcuts to import"
msgstr "Ne estas novaj ŝparvojoj por importi"

#: src/components/shortcuts-settings.jsx:975
msgid "Shortcuts imported. Exceeded max {SHORTCUTS_LIMIT}, so the rest are not imported."
msgstr "Ŝparvojoj importitaj. Superita maksimumo {SHORTCUTS_LIMIT}, do la ceteraj ne estas importitaj."

#: src/components/shortcuts-settings.jsx:976
#: src/components/shortcuts-settings.jsx:1000
msgid "Shortcuts imported"
msgstr "Ŝparvojoj importitaj"

#: src/components/shortcuts-settings.jsx:986
msgid "Import & append…"
msgstr "Importi kaj aldoni…"

#: src/components/shortcuts-settings.jsx:994
msgid "Override current shortcuts?"
msgstr "Ĉu anstataŭi nunajn ŝparvojojn?"

#: src/components/shortcuts-settings.jsx:995
msgid "Import shortcuts?"
msgstr "Ĉu importi ŝparvojojn?"

#: src/components/shortcuts-settings.jsx:1009
msgid "or override…"
msgstr "aŭ anstataŭi…"

#: src/components/shortcuts-settings.jsx:1009
msgid "Import…"
msgstr "Importi…"

#: src/components/shortcuts-settings.jsx:1018
msgid "Export"
msgstr "Eksporti"

#: src/components/shortcuts-settings.jsx:1033
msgid "Shortcuts copied"
msgstr "Ŝparvojoj kopiitaj"

#: src/components/shortcuts-settings.jsx:1036
msgid "Unable to copy shortcuts"
msgstr "Ne eblas kopii ŝparvojoj"

#: src/components/shortcuts-settings.jsx:1050
msgid "Shortcut settings copied"
msgstr "Ŝparvojaj agordoj kopiitaj"

#: src/components/shortcuts-settings.jsx:1053
msgid "Unable to copy shortcut settings"
msgstr "Ne eblas kopii ŝparvojajn agordojn"

#: src/components/shortcuts-settings.jsx:1083
msgid "Share"
msgstr "Diskonigi"

#: src/components/shortcuts-settings.jsx:1122
msgid "Saving shortcuts to instance server…"
msgstr "Konservante ŝparvojojn al nodservilo…"

#: src/components/shortcuts-settings.jsx:1129
msgid "Shortcuts saved"
msgstr "Ŝparvojoj konservitaj"

#: src/components/shortcuts-settings.jsx:1134
msgid "Unable to save shortcuts"
msgstr "Ne eblas konservi ŝparvojojn"

#: src/components/shortcuts-settings.jsx:1137
msgid "Sync to instance server"
msgstr "Sinkronigi al nodservilo"

#: src/components/shortcuts-settings.jsx:1145
msgid "{0, plural, one {# character} other {# characters}}"
msgstr "{0, plural, one {# skribsigno} other {# skribsignoj}}"

#: src/components/shortcuts-settings.jsx:1157
msgid "Raw Shortcuts JSON"
msgstr "Ne estas plu ŝparvojoj por importi"

#: src/components/shortcuts-settings.jsx:1170
msgid "Import/export settings from/to instance server (Very experimental)"
msgstr "Importi/eksporti agordojn de/al nodservilo (Tre eksperimenta)"

#: src/components/status.jsx:504
msgid "<0/> <1>boosted</1>"
msgstr "<0/> <1>diskonigita</1>"

#: src/components/status.jsx:603
msgid "Sorry, your current logged-in instance can't interact with this post from another instance."
msgstr "Pardonu, la nodo en kiu vi estas ensalutinta ne permesas vin interagi kun ĉi tiu afiŝo de alia nodo."

#: src/components/status.jsx:756
msgid "Unliked @{0}'s post"
msgstr "Ne plu ŝatis la afiŝon de {0}"

#: src/components/status.jsx:757
msgid "Liked @{0}'s post"
msgstr "Ŝatis la afiŝon de {0}"

#: src/components/status.jsx:796
msgid "Unbookmarked @{0}'s post"
msgstr "Ne plu legosignis la afiŝon de @{0}"

#: src/components/status.jsx:797
msgid "Bookmarked @{0}'s post"
msgstr "Legosignis la afiŝon de @{0}"

#: src/components/status.jsx:903
#: src/components/status.jsx:965
#: src/components/status.jsx:2364
#: src/components/status.jsx:2396
msgid "Unboost"
msgstr "Ne plu diskonigi"

#: src/components/status.jsx:919
#: src/components/status.jsx:2379
msgid "Quote"
msgstr "Citaĵo"

#: src/components/status.jsx:927
#: src/components/status.jsx:2388
msgid "Some media have no descriptions."
msgstr "Iuj plurmedioj ne havas priskribojn."

#: src/components/status.jsx:934
msgid "Old post (<0>{0}</0>)"
msgstr "Malnova afiŝo (<0>{0}</0>)"

#: src/components/status.jsx:953
#: src/components/status.jsx:1408
msgid "Unboosted @{0}'s post"
msgstr "Ne plu diskonigita la afiŝon de @{0}"

#: src/components/status.jsx:954
#: src/components/status.jsx:1409
msgid "Boosted @{0}'s post"
msgstr "Diskonigita la afiŝon de @{0}"

#: src/components/status.jsx:966
msgid "Boost…"
msgstr "Diskonigi…"

#: src/components/status.jsx:978
#: src/components/status.jsx:1693
#: src/components/status.jsx:2409
msgid "Unlike"
msgstr "Ne plu ŝati"

#: src/components/status.jsx:979
#: src/components/status.jsx:1693
#: src/components/status.jsx:1694
#: src/components/status.jsx:2409
#: src/components/status.jsx:2410
msgid "Like"
msgstr "Ŝatata"

#: src/components/status.jsx:988
#: src/components/status.jsx:2421
msgid "Unbookmark"
msgstr "Ne plu legosignis"

#: src/components/status.jsx:1096
msgid "View post by <0>@{0}</0>"
msgstr "Vidi afiŝon de <0>@{0}</0>"

#: src/components/status.jsx:1117
msgid "Show Edit History"
msgstr "Montri redaktan historion"

#: src/components/status.jsx:1120
msgid "Edited: {editedDateText}"
msgstr "Redaktita: {editedDateText}"

#: src/components/status.jsx:1187
#: src/components/status.jsx:3188
msgid "Embed post"
msgstr "Enkorpigi afiŝon"

#: src/components/status.jsx:1201
msgid "Conversation unmuted"
msgstr "Konversacion nesilentigita"

#: src/components/status.jsx:1201
msgid "Conversation muted"
msgstr "Konversacion silentigita"

#: src/components/status.jsx:1207
msgid "Unable to unmute conversation"
msgstr "Ne eblas nesilentigi konversacion"

#: src/components/status.jsx:1208
msgid "Unable to mute conversation"
msgstr "Ne eblas silentigi konversacion"

#: src/components/status.jsx:1217
msgid "Unmute conversation"
msgstr "Nesilentigi konversacion"

#: src/components/status.jsx:1224
msgid "Mute conversation"
msgstr "Silentigi konversacion"

#: src/components/status.jsx:1240
msgid "Post unpinned from profile"
msgstr "Afiŝo depinglinta de profilo"

#: src/components/status.jsx:1241
msgid "Post pinned to profile"
msgstr "Afiŝo alpinglita al profilo"

#: src/components/status.jsx:1246
msgid "Unable to unpin post"
msgstr "Ne eblas depingli afiŝon"

#: src/components/status.jsx:1246
msgid "Unable to pin post"
msgstr "Ne eblas alpingli afiŝon"

#: src/components/status.jsx:1255
msgid "Unpin from profile"
msgstr "Depingli de profilo"

#: src/components/status.jsx:1262
msgid "Pin to profile"
msgstr "Alpingli al la profilo"

#: src/components/status.jsx:1291
msgid "Delete this post?"
msgstr "Ĉu forigi ĉi tiun afiŝon?"

#: src/components/status.jsx:1307
msgid "Post deleted"
msgstr "Afiŝo forigita"

#: src/components/status.jsx:1310
msgid "Unable to delete post"
msgstr "Ne eblas forigi afiŝon"

#: src/components/status.jsx:1338
msgid "Report post…"
msgstr "Raporti afiŝon…"

#: src/components/status.jsx:1694
#: src/components/status.jsx:1730
#: src/components/status.jsx:2410
msgid "Liked"
msgstr "Ŝatita"

#: src/components/status.jsx:1727
#: src/components/status.jsx:2397
msgid "Boosted"
msgstr "Diskonigita"

#: src/components/status.jsx:1737
#: src/components/status.jsx:2422
msgid "Bookmarked"
msgstr "Legosignita"

#: src/components/status.jsx:1741
msgid "Pinned"
msgstr "Alpinglita"

#: src/components/status.jsx:1786
#: src/components/status.jsx:2241
msgid "Deleted"
msgstr "Forigita"

#: src/components/status.jsx:1827
msgid "{repliesCount, plural, one {# reply} other {# replies}}"
msgstr "{repliesCount, plural, one {# respondo} other {# respondoj}}"

#: src/components/status.jsx:1916
msgid "Thread{0}"
msgstr "Fadeno{0}"

#: src/components/status.jsx:1992
#: src/components/status.jsx:2054
#: src/components/status.jsx:2139
msgid "Show less"
msgstr "Montru malpli"

#: src/components/status.jsx:1992
#: src/components/status.jsx:2054
msgid "Show content"
msgstr "Montru envahon"

#: src/components/status.jsx:2139
msgid "Show media"
msgstr "Montri plurmedion"

#: src/components/status.jsx:2262
msgid "Edited"
msgstr "Redaktita"

#: src/components/status.jsx:2339
msgid "Comments"
msgstr "Komentoj"

#. More from [Author]
#: src/components/status.jsx:2648
msgid "More from <0/>"
msgstr "Pli de <0/>"

#: src/components/status.jsx:2949
msgid "Edit History"
msgstr "Redaktan historion"

#: src/components/status.jsx:2953
msgid "Failed to load history"
msgstr "Malsukcesis ŝargi historion"

#: src/components/status.jsx:2958
msgid "Loading…"
msgstr "Ŝargante…"

#: src/components/status.jsx:3193
msgid "HTML Code"
msgstr "HTML-kodo"

#: src/components/status.jsx:3210
msgid "HTML code copied"
msgstr "HTML-kodo kopiita"

#: src/components/status.jsx:3213
msgid "Unable to copy HTML code"
msgstr "Ne eblas kopii HTML-kodon"

#: src/components/status.jsx:3225
msgid "Media attachments:"
msgstr "Plurmediaj aldonaĵoj:"

#: src/components/status.jsx:3247
msgid "Account Emojis:"
msgstr "Emoĝioj de la konto:"

#: src/components/status.jsx:3278
#: src/components/status.jsx:3323
msgid "static URL"
msgstr "statika URL"

#: src/components/status.jsx:3292
msgid "Emojis:"
msgstr "Emoĝioj:"

#: src/components/status.jsx:3337
msgid "Notes:"
msgstr "Notoj:"

#: src/components/status.jsx:3341
msgid "This is static, unstyled and scriptless. You may need to apply your own styles and edit as needed."
msgstr "Ĉi tio estas senmova, ne stilita kaj senskriba. Vi eble bezonos apliki viajn proprajn stilojn kaj redakti laŭbezone."

#: src/components/status.jsx:3347
msgid "Polls are not interactive, becomes a list with vote counts."
msgstr "Balotenketoj ne estas interagaj kaj estos konvertitaj al listo kun balotkalkuloj."

#: src/components/status.jsx:3352
msgid "Media attachments can be images, videos, audios or any file types."
msgstr "Plurmediaj aldonaĵoj povas esti bildoj, filmetoj, sonaĵoj aŭ ajnaj dosiertipoj."

#: src/components/status.jsx:3358
msgid "Post could be edited or deleted later."
msgstr "Afiŝo povus esti redaktita aŭ forigita poste."

#: src/components/status.jsx:3364
msgid "Preview"
msgstr "Antaŭrigardo"

#: src/components/status.jsx:3373
msgid "Note: This preview is lightly styled."
msgstr "Noto: Ĉi tiu antaŭmontro estas malpeze stilita."

#. [Name] [Visibility icon] boosted
#: src/components/status.jsx:3615
msgid "<0/> <1/> boosted"
msgstr "<0/> <1/> diskonigita"

#: src/components/timeline.jsx:453
#: src/pages/settings.jsx:1130
msgid "New posts"
msgstr "Novaj afiŝoj"

#: src/components/timeline.jsx:554
#: src/pages/home.jsx:213
#: src/pages/notifications.jsx:824
#: src/pages/status.jsx:957
#: src/pages/status.jsx:1330
msgid "Try again"
msgstr "Provu denove"

#: src/components/timeline.jsx:588
msgid "{0, plural, one {# Boost} other {# Boosts}}"
msgstr "{0, plural, one {# Diskonigo} other {# Diskonigoj}}"

#: src/components/timeline.jsx:593
msgid "Pinned posts"
msgstr "Alpinglitaj afiŝoj"

#: src/components/timeline.jsx:946
#: src/components/timeline.jsx:953
#: src/pages/catchup.jsx:1893
msgid "Thread"
msgstr "Fadeno"

#: src/components/timeline.jsx:968
msgid "<0>Filtered</0>: <1>{0}</1>"
msgstr "<0>Filtrita</0>: <1>{0}</1>"

#: src/components/translation-block.jsx:152
msgid "Auto-translated from {sourceLangText}"
msgstr "Aŭtomate tradukita el {sourceLangText}"

#: src/components/translation-block.jsx:190
msgid "Translating…"
msgstr "Tradukante…"

#: src/components/translation-block.jsx:193
msgid "Translate from {sourceLangText} (auto-detected)"
msgstr "Traduki el {sourceLangText} (aŭtomate detektita)"

#: src/components/translation-block.jsx:194
msgid "Translate from {sourceLangText}"
msgstr "Traduki el {sourceLangText}"

#: src/components/translation-block.jsx:222
msgid "Auto ({0})"
msgstr "Aŭtomata ({0})"

#: src/components/translation-block.jsx:235
msgid "Failed to translate"
msgstr "Malsukcesis traduki"

#: src/compose.jsx:32
msgid "Editing source status"
msgstr "Redaktante la originalan mesaĝon"

#: src/compose.jsx:34
msgid "Replying to @{0}"
msgstr "Respondi al @{0}"

#: src/compose.jsx:62
msgid "You may close this page now."
msgstr "Vi povas fermi ĉi tiun paĝon nun."

#: src/compose.jsx:70
msgid "Close window"
msgstr "Fermi fenestron"

#: src/compose.jsx:86
msgid "Login required."
msgstr "Ensaluto bezonata."

#: src/compose.jsx:90
#: src/pages/http-route.jsx:91
#: src/pages/login.jsx:270
msgid "Go home"
msgstr "Iru hejmen"

#: src/pages/account-statuses.jsx:233
msgid "Account posts"
msgstr "Afiŝoj de la konto"

#: src/pages/account-statuses.jsx:240
msgid "{accountDisplay} (+ Replies)"
msgstr "{accountDisplay} (+ Respondoj)"

#: src/pages/account-statuses.jsx:242
msgid "{accountDisplay} (- Boosts)"
msgstr "{accountDisplay} (- Diskonigoj)"

#: src/pages/account-statuses.jsx:244
msgid "{accountDisplay} (#{tagged})"
msgstr "{accountDisplay} (#{tagged})"

#: src/pages/account-statuses.jsx:246
msgid "{accountDisplay} (Media)"
msgstr "{accountDisplay} (Plurmedio)"

#: src/pages/account-statuses.jsx:252
msgid "{accountDisplay} ({monthYear})"
msgstr "{accountDisplay} ({monthYear})"

#: src/pages/account-statuses.jsx:321
msgid "Clear filters"
msgstr "Malplenigi filtrojn"

#: src/pages/account-statuses.jsx:324
msgid "Clear"
msgstr "Malplenigi"

#: src/pages/account-statuses.jsx:338
msgid "Showing post with replies"
msgstr "Montrante afiŝon kun respondoj"

#: src/pages/account-statuses.jsx:343
msgid "+ Replies"
msgstr "+ Respondoj"

#: src/pages/account-statuses.jsx:349
msgid "Showing posts without boosts"
msgstr "Montrante afiŝojn sen diskonigoj"

#: src/pages/account-statuses.jsx:354
msgid "- Boosts"
msgstr "- Diskonigoj"

#: src/pages/account-statuses.jsx:360
msgid "Showing posts with media"
msgstr "Montrante afiŝojn kun plurmedio"

#: src/pages/account-statuses.jsx:377
msgid "Showing posts tagged with #{0}"
msgstr "Montrante afiŝojn etikeditaj kun #{0}"

#: src/pages/account-statuses.jsx:416
msgid "Showing posts in {0}"
msgstr "Montrante afiŝojn en {0}"

#: src/pages/account-statuses.jsx:505
msgid "Nothing to see here yet."
msgstr "Nenio vidinda ĉi tie ankoraŭ."

#: src/pages/account-statuses.jsx:506
#: src/pages/public.jsx:97
#: src/pages/trending.jsx:449
msgid "Unable to load posts"
msgstr "Ne eblas ŝargi afiŝojn"

#: src/pages/account-statuses.jsx:547
#: src/pages/account-statuses.jsx:577
msgid "Unable to fetch account info"
msgstr "Ne eblas ricevi informojn pri konto"

#: src/pages/account-statuses.jsx:554
msgid "Switch to account's instance {0}"
msgstr "Iri al la nodo de la konto {0}"

#: src/pages/account-statuses.jsx:584
msgid "Switch to my instance (<0>{currentInstance}</0>)"
msgstr "Iri al mia nodo (<0>{currentInstance}</0>)"

#: src/pages/account-statuses.jsx:646
msgid "Month"
msgstr "Monato"

#: src/pages/accounts.jsx:55
msgid "Current"
msgstr "Nuna"

#: src/pages/accounts.jsx:101
msgid "Default"
msgstr "Defaŭlto"

#: src/pages/accounts.jsx:123
msgid "Switch to this account"
msgstr "Ŝalti al ĉi tiu konto"

#: src/pages/accounts.jsx:132
msgid "Switch in new tab/window"
msgstr "Ŝalti en novan langeton/fenestron"

#: src/pages/accounts.jsx:146
msgid "View profile…"
msgstr "Vidi profilon…"

#: src/pages/accounts.jsx:163
msgid "Set as default"
msgstr "Agordi kiel defaŭltan"

#: src/pages/accounts.jsx:173
msgid "Log out <0>@{0}</0>?"
msgstr "Ĉu elsaluti <0>@{0}</0>?"

#: src/pages/accounts.jsx:196
msgid "Log out…"
msgstr "Elsaluti…"

#: src/pages/accounts.jsx:209
msgid "Add an existing account"
msgstr "Aldoni ekzistantan konton"

#: src/pages/accounts.jsx:216
msgid "Note: <0>Default</0> account will always be used for first load. Switched accounts will persist during the session."
msgstr "Noto: <0>Defaŭlta</0> konto ĉiam estos uzata por la unua ŝarĝo. Ŝanĝitaj kontoj daŭros dum la sesio."

#: src/pages/bookmarks.jsx:25
msgid "No bookmarks yet. Go bookmark something!"
msgstr "Ankoraŭ neniuj legosignoj. Iru legosigni ion!"

#: src/pages/bookmarks.jsx:26
msgid "Unable to load bookmarks."
msgstr "Ne eblas ŝargi legosignoj."

#: src/pages/catchup.jsx:54
msgid "last 1 hour"
msgstr "la lasta horo"

#: src/pages/catchup.jsx:55
msgid "last 2 hours"
msgstr "la lastaj 2 horoj"

#: src/pages/catchup.jsx:56
msgid "last 3 hours"
msgstr "la lastaj 3 horoj"

#: src/pages/catchup.jsx:57
msgid "last 4 hours"
msgstr "la lastaj 4 horoj"

#: src/pages/catchup.jsx:58
msgid "last 5 hours"
msgstr "la lastaj 5 horoj"

#: src/pages/catchup.jsx:59
msgid "last 6 hours"
msgstr "la lastaj 6 horoj"

#: src/pages/catchup.jsx:60
msgid "last 7 hours"
msgstr "la lastaj 7 horoj"

#: src/pages/catchup.jsx:61
msgid "last 8 hours"
msgstr "la lastaj 8 horoj"

#: src/pages/catchup.jsx:62
msgid "last 9 hours"
msgstr "la lastaj 9 horoj"

#: src/pages/catchup.jsx:63
msgid "last 10 hours"
msgstr "la lastaj 10 horoj"

#: src/pages/catchup.jsx:64
msgid "last 11 hours"
msgstr "la lastaj 11 horoj"

#: src/pages/catchup.jsx:65
msgid "last 12 hours"
msgstr "la lastaj 12 horoj"

#: src/pages/catchup.jsx:66
msgid "beyond 12 hours"
msgstr "pli ol 12 horoj"

#: src/pages/catchup.jsx:73
msgid "Followed tags"
msgstr "Sekvataj etikedoj"

#: src/pages/catchup.jsx:74
msgid "Groups"
msgstr "Grupoj"

#: src/pages/catchup.jsx:596
msgid "Showing {selectedFilterCategory, select, all {all posts} original {original posts} replies {replies} boosts {boosts} followedTags {followed tags} groups {groups} filtered {filtered posts}}, {sortBy, select, createdAt {{sortOrder, select, asc {oldest} desc {latest}}} reblogsCount {{sortOrder, select, asc {fewest boosts} desc {most boosts}}} favouritesCount {{sortOrder, select, asc {fewest likes} desc {most likes}}} repliesCount {{sortOrder, select, asc {fewest replies} desc {most replies}}} density {{sortOrder, select, asc {least dense} desc {most dense}}}} first{groupBy, select, account {, grouped by authors} other {}}"
msgstr "Montrante {selectedFilterCategory, select, all {ĉiuj afiŝoj} original {originalaj afiŝoj} replies {respondoj} boosts {diskonigoj} followedTags {sekvitaj etikedoj} groups {grupoj} filtered {filtritaj afiŝoj}}, {sortBy, select, createdAt {{sortOrder, select, asc {plej malnova} desc {lastaj}}} reblogsCount {{sortOrder, select, asc {plej malmultaj diskonigoj} desc {plej multaj diskonigoj}}} favouritesCount {{sortOrder, select, asc {plej malmutaj ŝatataj} desc {plej multaj ŝatataj}}} repliesCount {{sortOrder, select, asc {plej malmultaj respondoj} desc {plej multaj respondoj}}} density {{sortOrder, select, asc {malplej densa} desc {plej densa}}}} first{groupBy, select, account {, grupigitaj per aŭtoroj} other {}}"

#: src/pages/catchup.jsx:882
#: src/pages/catchup.jsx:906
msgid "Catch-up <0>beta</0>"
msgstr "Aktualiĝi <0>beta</0>"

#: src/pages/catchup.jsx:896
#: src/pages/catchup.jsx:1585
msgid "Help"
msgstr "Helpo"

#: src/pages/catchup.jsx:912
msgid "What is this?"
msgstr "Kio estas ĉi tio?"

#: src/pages/catchup.jsx:915
msgid "Catch-up is a separate timeline for your followings, offering a high-level view at a glance, with a simple, email-inspired interface to effortlessly sort and filter through posts."
msgstr "Aktualiĝi estas aparta templinio por viaj sekvantaroj, ofertante altnivelan vidon je unu ekrigardo, kun simpla, retpoŝta interfaco por senpene ordigi kaj filtri afiŝojn."

#: src/pages/catchup.jsx:926
msgid "Preview of Catch-up UI"
msgstr "Antaŭrigardo de Aktualiĝo UI"

#: src/pages/catchup.jsx:935
msgid "Let's catch up"
msgstr "Ni atingu"

#: src/pages/catchup.jsx:940
msgid "Let's catch up on the posts from your followings."
msgstr "Ni atingu la afiŝojn de viaj sekvantoj."

#: src/pages/catchup.jsx:944
msgid "Show me all posts from…"
msgstr "Montri al mi ĉiujn afiŝojn de…"

#: src/pages/catchup.jsx:967
msgid "until the max"
msgstr "ĝis la maksimumo"

#: src/pages/catchup.jsx:997
msgid "Catch up"
msgstr "Atingi"

#: src/pages/catchup.jsx:1003
msgid "Overlaps with your last catch-up"
msgstr "Interkovri kun via lasta aktualiĝo"

#: src/pages/catchup.jsx:1015
msgid "Until the last catch-up ({0})"
msgstr "Ĝis la lasta aktualiĝo ({0})"

#: src/pages/catchup.jsx:1024
msgid "Note: your instance might only show a maximum of 800 posts in the Home timeline regardless of the time range. Could be less or more."
msgstr "Noto: Via nodo povus nur montri maksimume 800 afiŝojn en la Hejma templinio sendepende de la tempointervalo. Povus esti malpli aŭ pli."

#: src/pages/catchup.jsx:1034
msgid "Previously…"
msgstr "Antaŭe…"

#: src/pages/catchup.jsx:1052
msgid "{0, plural, one {# post} other {# posts}}"
msgstr "{0, plural, one {# afiŝo} other {# afiŝoj}}"

#: src/pages/catchup.jsx:1062
msgid "Remove this catch-up?"
msgstr "Ĉu forigi ĉi tiun aktualiĝon?"

#: src/pages/catchup.jsx:1083
msgid "Note: Only max 3 will be stored. The rest will be automatically removed."
msgstr "Noto: Nur maksimume 3 estos konservitaj. La resto estos aŭtomate forigita."

#: src/pages/catchup.jsx:1098
msgid "Fetching posts…"
msgstr "Ricevante afiŝojn…"

#: src/pages/catchup.jsx:1101
msgid "This might take a while."
msgstr "Ĉi tio eble daŭros iom da tempo."

#: src/pages/catchup.jsx:1136
msgid "Reset filters"
msgstr "Restartigi filtrilojn"

#: src/pages/catchup.jsx:1144
#: src/pages/catchup.jsx:1591
msgid "Top links"
msgstr "Popularaj ligiloj"

#: src/pages/catchup.jsx:1261
msgid "Shared by {0}"
msgstr "Diskonigita de {0}"

#: src/pages/catchup.jsx:1316
#: src/pages/mentions.jsx:147
#: src/pages/search.jsx:222
msgid "All"
msgstr "Ĉiuj"

#: src/pages/catchup.jsx:1401
msgid "{0, plural, one {# author} other {# authors}}"
msgstr "{0, plural, one {# aŭtoro} other {# aŭtoroj}}"

#: src/pages/catchup.jsx:1413
msgid "Sort"
msgstr "Ordigi"

#: src/pages/catchup.jsx:1444
msgid "Date"
msgstr "Dato"

#: src/pages/catchup.jsx:1448
msgid "Density"
msgstr "Denseco"

#: src/pages/catchup.jsx:1486
msgid "Authors"
msgstr "Aŭtoroj"

#: src/pages/catchup.jsx:1487
msgid "None"
msgstr "Nenio"

#: src/pages/catchup.jsx:1503
msgid "Show all authors"
msgstr "Montri ĉiujn aŭtorojn"

#: src/pages/catchup.jsx:1554
msgid "You don't have to read everything."
msgstr "Vi ne devas legi ĉion."

#: src/pages/catchup.jsx:1555
msgid "That's all."
msgstr "Jen ĉio."

#: src/pages/catchup.jsx:1563
msgid "Back to top"
msgstr "Supren"

#: src/pages/catchup.jsx:1594
msgid "Links shared by followings, sorted by shared counts, boosts and likes."
msgstr "Ligiloj diskonigitaj per sekvantoj, ordigitaj laŭ komunaj kalkuloj, diskonigoj kaj ŝatoj."

#: src/pages/catchup.jsx:1600
msgid "Sort: Density"
msgstr "Ordigo: Denseco"

#: src/pages/catchup.jsx:1603
msgid "Posts are sorted by information density or depth. Shorter posts are \"lighter\" while longer posts are \"heavier\". Posts with photos are \"heavier\" than posts without photos."
msgstr "Afiŝoj estas ordigitaj laŭ informa denseco aŭ profundo. Pli mallongaj afiŝoj estas \"pli malpezaj\" dum pli longaj afiŝoj estas \"pli pezaj\". Afiŝoj kun fotoj estas \"pli pezaj\" ol afiŝoj sen fotoj."

#: src/pages/catchup.jsx:1610
msgid "Group: Authors"
msgstr "Grupo: Aŭtoroj"

#: src/pages/catchup.jsx:1613
msgid "Posts are grouped by authors, sorted by posts count per author."
msgstr "Afiŝoj estas grupigitaj laŭ aŭtoroj, ordigitaj laŭ nombro de afiŝoj per aŭtoro."

#: src/pages/catchup.jsx:1660
msgid "Next author"
msgstr "Sekva aŭtoro"

#: src/pages/catchup.jsx:1668
msgid "Previous author"
msgstr "Antaŭa aŭtoro"

#: src/pages/catchup.jsx:1684
msgid "Scroll to top"
msgstr "Rulumi supren"

#: src/pages/catchup.jsx:1875
msgid "Filtered: {0}"
msgstr "Filtrita: {0}"

#: src/pages/favourites.jsx:25
msgid "No likes yet. Go like something!"
msgstr "Ankoraŭ neniuj stemuloj. Iru, trovu ion por ŝati!"

#: src/pages/favourites.jsx:26
msgid "Unable to load likes."
msgstr "Ne eblas ŝargi stelumojn."

#: src/pages/filters.jsx:23
msgid "Home and lists"
msgstr "Hejmo kaj listoj"

#: src/pages/filters.jsx:25
msgid "Public timelines"
msgstr "Publikaj templinioj"

#: src/pages/filters.jsx:26
msgid "Conversations"
msgstr "Konversacioj"

#: src/pages/filters.jsx:27
msgid "Profiles"
msgstr "Profiloj"

#: src/pages/filters.jsx:42
msgid "Never"
msgstr "Neniam"

#: src/pages/filters.jsx:103
#: src/pages/filters.jsx:228
msgid "New filter"
msgstr "Nova filtrilo"

#: src/pages/filters.jsx:151
msgid "{0, plural, one {# filter} other {# filters}}"
msgstr "{0, plural, one {# filtrilo} other {# filtriloj}}"

#: src/pages/filters.jsx:166
msgid "Unable to load filters."
msgstr "Ne eblas ŝargi filtrilojn."

#: src/pages/filters.jsx:170
msgid "No filters yet."
msgstr "Ankoraŭ ne estas filtriloj."

#: src/pages/filters.jsx:177
msgid "Add filter"
msgstr "Aldoni filtrilon"

#: src/pages/filters.jsx:228
msgid "Edit filter"
msgstr "Redakti filtrilon"

#: src/pages/filters.jsx:345
msgid "Unable to edit filter"
msgstr "Ne eblas redakti filtrilon"

#: src/pages/filters.jsx:346
msgid "Unable to create filter"
msgstr "Ne eblas krei filtrilon"

#: src/pages/filters.jsx:355
msgid "Title"
msgstr "Titolo"

#: src/pages/filters.jsx:396
msgid "Whole word"
msgstr "Tuta vorto"

#: src/pages/filters.jsx:422
msgid "No keywords. Add one."
msgstr "Ne estas ŝlosilvortoj. Aldonu unu."

#: src/pages/filters.jsx:449
msgid "Add keyword"
msgstr "Aldoni ŝlosilvorton"

#: src/pages/filters.jsx:453
msgid "{0, plural, one {# keyword} other {# keywords}}"
msgstr "{0, plural, one {# ŝlosilvorto} other {# ŝlosilvortoj}}"

#: src/pages/filters.jsx:466
msgid "Filter from…"
msgstr "Filtri de…"

#: src/pages/filters.jsx:492
msgid "* Not implemented yet"
msgstr "* Ankoraŭ ne disponigita"

#: src/pages/filters.jsx:498
msgid "Status: <0><1/></0>"
msgstr "Stato: <0><1/></0>"

#: src/pages/filters.jsx:507
msgid "Change expiry"
msgstr "Ŝanĝi eksvalidiĝon"

#: src/pages/filters.jsx:507
msgid "Expiry"
msgstr "Eksvalidiĝo"

#: src/pages/filters.jsx:526
msgid "Filtered post will be…"
msgstr "Filtrita afiŝo estos…"

#: src/pages/filters.jsx:536
msgid "minimized"
msgstr "minimumigita"

#: src/pages/filters.jsx:546
msgid "hidden"
msgstr "kaŝita"

#: src/pages/filters.jsx:563
msgid "Delete this filter?"
msgstr "Ĉu forigi ĉi tiun filtrilon?"

#: src/pages/filters.jsx:576
msgid "Unable to delete filter."
msgstr "Ne eblas forigi filtrilon."

#: src/pages/filters.jsx:608
msgid "Expired"
msgstr "Finiĝita"

#: src/pages/filters.jsx:610
msgid "Expiring <0/>"
msgstr "Finiĝanta <0/>"

#: src/pages/filters.jsx:614
msgid "Never expires"
msgstr "Neniam finiĝas"

#: src/pages/followed-hashtags.jsx:70
msgid "{0, plural, one {# hashtag} other {# hashtags}}"
msgstr "{0, plural, one {# kradvorto} other {# kradvortoj}}"

#: src/pages/followed-hashtags.jsx:85
msgid "Unable to load followed hashtags."
msgstr "Ne eblas ŝargi sekvatajn kradvortojn."

#: src/pages/followed-hashtags.jsx:89
msgid "No hashtags followed yet."
msgstr "Neniuj kradvortoj ankoraŭ sekvis."

#: src/pages/following.jsx:143
msgid "Nothing to see here."
msgstr "Nenio vidinda ĉi tie."

#: src/pages/following.jsx:144
#: src/pages/list.jsx:108
msgid "Unable to load posts."
msgstr "Ne eblas ŝargi afiŝojn."

#: src/pages/hashtag.jsx:55
msgid "{hashtagTitle} (Media only) on {instance}"
msgstr "{hashtagTitle} (Nur plurmedio) en {instance}"

#: src/pages/hashtag.jsx:56
msgid "{hashtagTitle} on {instance}"
msgstr "{hashtagTitle} en {instance}"

#: src/pages/hashtag.jsx:58
msgid "{hashtagTitle} (Media only)"
msgstr "{hashtagTitle} (Nur plurmedio)"

#: src/pages/hashtag.jsx:59
msgid "{hashtagTitle}"
msgstr "{hashtagTitle}"

#: src/pages/hashtag.jsx:181
msgid "No one has posted anything with this tag yet."
msgstr "Neniu ankoraŭ afiŝis ion kun ĉi tiu kradvorto."

#: src/pages/hashtag.jsx:182
msgid "Unable to load posts with this tag"
msgstr "Ne eblas ŝargi afiŝojn kun tiu ĉi kradvorto"

#: src/pages/hashtag.jsx:208
msgid "Unfollow #{hashtag}?"
msgstr "Ĉu ĉesi sekvi #{hashtag}?"

#: src/pages/hashtag.jsx:223
msgid "Unfollowed #{hashtag}"
msgstr "Nesekvita #{hashtag}"

#: src/pages/hashtag.jsx:238
msgid "Followed #{hashtag}"
msgstr "Sekvita #{hashtag}"

#: src/pages/hashtag.jsx:254
msgid "Following…"
msgstr "Sekvatoj…"

#: src/pages/hashtag.jsx:282
msgid "Unfeatured on profile"
msgstr "Nemontrita en profilo"

#: src/pages/hashtag.jsx:296
msgid "Unable to unfeature on profile"
msgstr "Ne eblas nemontri en profilo"

#: src/pages/hashtag.jsx:305
#: src/pages/hashtag.jsx:321
msgid "Featured on profile"
msgstr "Montrita en profilo"

#: src/pages/hashtag.jsx:328
msgid "Feature on profile"
msgstr "Montri en profilo"

#: src/pages/hashtag.jsx:393
msgid "{TOTAL_TAGS_LIMIT, plural, other {Max # tags}}"
msgstr "{TOTAL_TAGS_LIMIT, plural, other {Maks. # kradvortoj}}"

#: src/pages/hashtag.jsx:396
msgid "Add hashtag"
msgstr "Aldoni kradvorton"

#: src/pages/hashtag.jsx:428
msgid "Remove hashtag"
msgstr "Forigi kradvorton"

#: src/pages/hashtag.jsx:442
msgid "{SHORTCUTS_LIMIT, plural, one {Max # shortcut reached. Unable to add shortcut.} other {Max # shortcuts reached. Unable to add shortcut.}}"
msgstr "{SHORTCUTS_LIMIT, plural, one {Maks. # ŝparvojo atingita. Ne eblas aldoni ŝparvojon.} other {Maks. # ŝparvojoj atingitaj. Ne eblas aldoni ŝparvojon.}}"

#: src/pages/hashtag.jsx:471
msgid "This shortcut already exists"
msgstr "Ĉi tiu ŝparvojo jam ekzistas"

#: src/pages/hashtag.jsx:474
msgid "Hashtag shortcut added"
msgstr "Kradvorto-ŝparvojo aldonita"

#: src/pages/hashtag.jsx:480
msgid "Add to Shortcuts"
msgstr "Aldoni al ŝparvojoj"

#: src/pages/hashtag.jsx:486
#: src/pages/public.jsx:139
#: src/pages/trending.jsx:478
msgid "Enter a new instance e.g. \"mastodon.social\""
msgstr "Entajpi novan nodon, ekz. \"mastodon.social\""

#: src/pages/hashtag.jsx:489
#: src/pages/public.jsx:142
#: src/pages/trending.jsx:481
msgid "Invalid instance"
msgstr "Senvalida nodo"

#: src/pages/hashtag.jsx:503
#: src/pages/public.jsx:156
#: src/pages/trending.jsx:493
msgid "Go to another instance…"
msgstr "Iri al alia nodo…"

#: src/pages/hashtag.jsx:516
#: src/pages/public.jsx:169
#: src/pages/trending.jsx:504
msgid "Go to my instance (<0>{currentInstance}</0>)"
msgstr "Iri al mia nodo (<0>{currentInstance}</0>)"

#: src/pages/home.jsx:209
msgid "Unable to fetch notifications."
msgstr "Ne eblas ŝarĝi sciigojn."

#: src/pages/home.jsx:229
msgid "<0>New</0> <1>Follow Requests</1>"
msgstr "<0>Nova</0> <1>Petoj de sekvado</1>"

#: src/pages/home.jsx:235
msgid "See all"
msgstr "Vidi ĉion"

#: src/pages/http-route.jsx:68
msgid "Resolving…"
msgstr "Solvante…"

#: src/pages/http-route.jsx:79
msgid "Unable to resolve URL"
msgstr "Ne eblas solvi retadreson"

#: src/pages/list.jsx:107
msgid "Nothing yet."
msgstr "Ankoraŭ nenio."

#: src/pages/list.jsx:176
#: src/pages/list.jsx:279
msgid "Manage members"
msgstr "Administri membrojn"

#: src/pages/list.jsx:313
msgid "Remove <0>@{0}</0> from list?"
msgstr "Ĉu forigi <0>@{0}</0> el listo?"

#: src/pages/list.jsx:359
msgid "Remove…"
msgstr "Forigi…"

#: src/pages/lists.jsx:93
msgid "{0, plural, one {# list} other {# lists}}"
msgstr "{0, plural, one {#listo} other {# listoj}}"

#: src/pages/lists.jsx:108
msgid "No lists yet."
msgstr "Ankoraŭ ne estas listoj."

#: src/pages/login.jsx:109
#: src/pages/login.jsx:122
msgid "Failed to register application"
msgstr "Malsukcesis registri aplikaĵon"

#: src/pages/login.jsx:208
msgid "instance domain"
msgstr "noda domajno"

#: src/pages/login.jsx:232
msgid "e.g. “mastodon.social”"
msgstr "ekz. “mastodon.social”"

#: src/pages/login.jsx:243
msgid "Failed to log in. Please try again or try another instance."
msgstr "Malsukcesis ensaluti. Bonvolu provi denove aŭ provi alian nodon."

#: src/pages/login.jsx:255
msgid "Continue with {selectedInstanceText}"
msgstr "Daŭrigi per {selectedInstanceText}"

#: src/pages/login.jsx:256
msgid "Continue"
msgstr "Daŭrigi"

#: src/pages/login.jsx:264
msgid "Don't have an account? Create one!"
msgstr "Ĉu vi ankoraŭ ne havas konton? Kreu unu!"

#: src/pages/mentions.jsx:20
msgid "Private mentions"
msgstr "Privataj mencioj"

#: src/pages/mentions.jsx:159
msgid "Private"
msgstr "Privata"

#: src/pages/mentions.jsx:169
msgid "No one mentioned you :("
msgstr "Neniu menciis vin :("

#: src/pages/mentions.jsx:170
msgid "Unable to load mentions."
msgstr "Ne eblas ŝargi menciojn."

#: src/pages/notifications.jsx:103
msgid "You don't follow"
msgstr "Vi ne sekvas"

#: src/pages/notifications.jsx:104
msgid "Who don't follow you"
msgstr "Kiuj ne sekvas vin"

#: src/pages/notifications.jsx:105
msgid "With a new account"
msgstr "Kun nova konto"

#: src/pages/notifications.jsx:106
msgid "Who unsolicitedly private mention you"
msgstr "Kiu nepetite privata mencias vin"

#: src/pages/notifications.jsx:107
msgid "Who are limited by server moderators"
msgstr "Kiuj estas limigitaj de servilaj moderigantoj"

#: src/pages/notifications.jsx:538
#: src/pages/notifications.jsx:872
msgid "Notifications settings"
msgstr "Agordoj pri sciigoj"

#: src/pages/notifications.jsx:556
msgid "New notifications"
msgstr "Novaj sciigoj"

#: src/pages/notifications.jsx:567
msgid "{0, plural, one {Announcement} other {Announcements}}"
msgstr "{0, plural, one {Anonco} other {Anoncoj}}"

#: src/pages/notifications.jsx:614
#: src/pages/settings.jsx:1118
msgid "Follow requests"
msgstr "Petoj de sekvado"

#: src/pages/notifications.jsx:619
msgid "{0, plural, one {# follow request} other {# follow requests}}"
msgstr "{0, plural, one {# peto de sekvado} other {# petoj de sekvado}}"

#: src/pages/notifications.jsx:674
msgid "{0, plural, one {Filtered notifications from # person} other {Filtered notifications from # people}}"
msgstr "{0, plural, one {Filtritaj sciigoj de # persono} other {Filtritaj sciigoj de # personoj}}"

#: src/pages/notifications.jsx:740
msgid "Only mentions"
msgstr "Nur mencioj"

#: src/pages/notifications.jsx:744
msgid "Today"
msgstr "Hodiaŭ"

#: src/pages/notifications.jsx:749
msgid "You're all caught up."
msgstr "Vi estas aktualiĝa."

#: src/pages/notifications.jsx:772
msgid "Yesterday"
msgstr "Hieraŭ"

#: src/pages/notifications.jsx:820
msgid "Unable to load notifications"
msgstr "Ne eblas ŝargi sciigojn"

#: src/pages/notifications.jsx:899
msgid "Notifications settings updated"
msgstr "Sciigaj agordoj ĝisdatigitaj"

#: src/pages/notifications.jsx:907
msgid "Filter out notifications from people:"
msgstr "Filtri sciigojn de homoj:"

#: src/pages/notifications.jsx:921
msgid "Filter"
msgstr "Filtrilo"

#: src/pages/notifications.jsx:924
msgid "Ignore"
msgstr "Ignori"

#: src/pages/notifications.jsx:997
msgid "Updated <0>{0}</0>"
msgstr "Ĝisdatigita <0>{0}</0>"

#: src/pages/notifications.jsx:1065
msgid "View notifications from <0>@{0}</0>"
msgstr "Vidi sciigojn de <0>@{0}</0>"

#: src/pages/notifications.jsx:1086
msgid "Notifications from <0>@{0}</0>"
msgstr "Sciigoj de <0>@{0}</0>"

#: src/pages/notifications.jsx:1153
msgid "Notifications from @{0} will not be filtered from now on."
msgstr "Sciigoj de @{0} ne estos filtritaj ekde nun."

#: src/pages/notifications.jsx:1158
msgid "Unable to accept notification request"
msgstr "Ne eblas akcepti sciigan peton"

#: src/pages/notifications.jsx:1163
msgid "Allow"
msgstr "Permesi"

#: src/pages/notifications.jsx:1183
msgid "Notifications from @{0} will not show up in Filtered notifications from now on."
msgstr "Sciigoj de @{0} ne aperos en Filtritaj sciigoj ekde nun."

#: src/pages/notifications.jsx:1188
msgid "Unable to dismiss notification request"
msgstr "Ne eblas malakcepti sciigan peton"

#: src/pages/notifications.jsx:1193
msgid "Dismiss"
msgstr "Fermi"

#: src/pages/notifications.jsx:1208
msgid "Dismissed"
msgstr "Fermita"

#: src/pages/public.jsx:27
msgid "Local timeline ({instance})"
msgstr "Loka templinio ({instance})"

#: src/pages/public.jsx:28
msgid "Federated timeline ({instance})"
msgstr "Fratara templinio ({instance})"

#: src/pages/public.jsx:90
msgid "Local timeline"
msgstr "Loka templinio"

#: src/pages/public.jsx:90
msgid "Federated timeline"
msgstr "Fratara templinio"

#: src/pages/public.jsx:96
msgid "No one has posted anything yet."
msgstr "Neniu ankoraŭ afiŝis ion."

#: src/pages/public.jsx:123
msgid "Switch to Federated"
msgstr "Ŝalti al Federacia"

#: src/pages/public.jsx:130
msgid "Switch to Local"
msgstr "Ŝalti al Loka"

#: src/pages/search.jsx:43
msgid "Search: {q} (Posts)"
msgstr "Serĉi: {q} (Afiŝoj)"

#: src/pages/search.jsx:46
msgid "Search: {q} (Accounts)"
msgstr "Serĉi: {q} (Kontoj)"

#: src/pages/search.jsx:49
msgid "Search: {q} (Hashtags)"
msgstr "Serĉi: {q} (Kradvortoj)"

#: src/pages/search.jsx:52
msgid "Search: {q}"
msgstr "Serĉi: {q}"

#: src/pages/search.jsx:232
#: src/pages/search.jsx:314
msgid "Hashtags"
msgstr "Kradvortoj"

#: src/pages/search.jsx:264
#: src/pages/search.jsx:318
#: src/pages/search.jsx:388
msgid "See more"
msgstr "Vidi pli"

#: src/pages/search.jsx:290
msgid "See more accounts"
msgstr "Vidi pli da kontoj"

#: src/pages/search.jsx:304
msgid "No accounts found."
msgstr "Neniuj kontoj trovitaj."

#: src/pages/search.jsx:360
msgid "See more hashtags"
msgstr "Vidi pli da kradvortoj"

#: src/pages/search.jsx:374
msgid "No hashtags found."
msgstr "Neniuj kradvortoj trovitaj."

#: src/pages/search.jsx:418
msgid "See more posts"
msgstr "Vidi pli da afiŝoj"

#: src/pages/search.jsx:432
msgid "No posts found."
msgstr "Neniuj afiŝoj trovitaj."

#: src/pages/search.jsx:476
msgid "Enter your search term or paste a URL above to get started."
msgstr "Enigi vian serĉterminon aŭ alglui URL-on supre por komenci."

#: src/pages/settings.jsx:81
msgid "Settings"
msgstr "Agordoj"

#: src/pages/settings.jsx:90
msgid "Appearance"
msgstr "Apero"

#: src/pages/settings.jsx:166
msgid "Light"
msgstr "Hela"

#: src/pages/settings.jsx:177
msgid "Dark"
msgstr "Malhela"

#: src/pages/settings.jsx:190
msgid "Auto"
msgstr "Aŭtomata"

#: src/pages/settings.jsx:200
msgid "Text size"
msgstr "Tekstogrando"

#. Preview of one character, in smallest size
#. Preview of one character, in largest size
#: src/pages/settings.jsx:205
#: src/pages/settings.jsx:230
msgid "A"
msgstr "A"

#: src/pages/settings.jsx:244
msgid "Display language"
msgstr "Lingvo de la fasado"

#: src/pages/settings.jsx:253
msgid "Volunteer translations"
msgstr "Volontulaj tradukoj"

#: src/pages/settings.jsx:264
msgid "Posting"
msgstr "Afiŝante"

#: src/pages/settings.jsx:271
msgid "Default visibility"
msgstr "Defaŭlta videblo"

#: src/pages/settings.jsx:272
#: src/pages/settings.jsx:318
msgid "Synced"
msgstr "Sinkronigita"

#: src/pages/settings.jsx:297
msgid "Failed to update posting privacy"
msgstr "Malsukcesis ĝisdatigi afiŝan privatecon"

#: src/pages/settings.jsx:320
msgid "Synced to your instance server's settings. <0>Go to your instance ({instance}) for more settings.</0>"
msgstr "Sinkronigita kun la agordoj de via nodservilo. <0>Iru al via nodo ({instance}) por pliaj agordoj.</0>"

#: src/pages/settings.jsx:335
msgid "Experiments"
msgstr "Eksperimentoj"

#: src/pages/settings.jsx:348
msgid "Auto refresh timeline posts"
msgstr "Aŭtomate aktualigi templiniajn afiŝojn"

#: src/pages/settings.jsx:360
msgid "Boosts carousel"
msgstr "Karuselon de diskonigoj"

#: src/pages/settings.jsx:376
msgid "Post translation"
msgstr "Traduko de afiŝoj"

#: src/pages/settings.jsx:387
msgid "Translate to"
msgstr "Traduki al"

#: src/pages/settings.jsx:398
msgid "System language ({systemTargetLanguageText})"
msgstr "Sistemlingvo ({systemTargetLanguageText})"

#: src/pages/settings.jsx:424
msgid "{0, plural, =0 {Hide \"Translate\" button for:} other {Hide \"Translate\" button for (#):}}"
msgstr "{0, plural, =0 {Kaŝi la butonon \"Traduki\" por:} other {Kaŝi la butonon \"Traduki\" por (#):}}"

#: src/pages/settings.jsx:478
msgid "Note: This feature uses external translation services, powered by <0>Lingva API</0> & <1>Lingva Translate</1>."
msgstr "Noto: Ĉi tiu funkcio uzas eksterajn tradukservojn, funkciigitajn de <0>Lingva API</0> kaj <1>Lingva Translate</1>."

#: src/pages/settings.jsx:512
msgid "Auto inline translation"
msgstr "Maŝintradukado"

#: src/pages/settings.jsx:516
msgid "Automatically show translation for posts in timeline. Only works for <0>short</0> posts without content warning, media and poll."
msgstr "Aŭtomate montri tradukon por afiŝoj en templinio. Funkcias nur por <0>mallongaj</0> afiŝoj sen enhavaverto, plurmedio kaj balotenketo."

#: src/pages/settings.jsx:536
msgid "GIF Picker for composer"
msgstr "GIF-Elektilo por redaktado"

#: src/pages/settings.jsx:540
msgid "Note: This feature uses external GIF search service, powered by <0>GIPHY</0>. G-rated (suitable for viewing by all ages), tracking parameters are stripped, referrer information is omitted from requests, but search queries and IP address information will still reach their servers."
msgstr "Noto: Ĉi tiu funkcio uzas eksteran GIF-serĉan servon, funkciigitan de <0>GIPHY</0>. G-taksita (taŭga por spektado de ĉiuj aĝoj), spuraj parametroj estas nudigitaj, referencaj informoj estas preterlasitaj de petoj, sed serĉdemandoj kaj IP-adresinformoj ankoraŭ atingos iliajn servilojn."

#: src/pages/settings.jsx:569
msgid "Image description generator"
msgstr "Generilo pri priskribo de bildoj"

#: src/pages/settings.jsx:574
msgid "Only for new images while composing new posts."
msgstr "Nur por novaj bildoj dum verkado de novaj afiŝoj."

#: src/pages/settings.jsx:581
msgid "Note: This feature uses external AI service, powered by <0>img-alt-api</0>. May not work well. Only for images and in English."
msgstr "Noto: Ĉi tiu funkcio uzas eksteran AI-servon, funkciigitan de <0>img-alt-api</0>. Eble ne funkcias bone. Nur por bildoj kaj en la angla."

#: src/pages/settings.jsx:607
msgid "Server-side grouped notifications"
msgstr "Servil-flankaj grupigitaj sciigoj"

#: src/pages/settings.jsx:611
msgid "Alpha-stage feature. Potentially improved grouping window but basic grouping logic."
msgstr "Funkcio en alfa-versio. Eble plibonigita grupigfenestro, sed kun baza grupiglogiko."

#: src/pages/settings.jsx:632
msgid "\"Cloud\" import/export for shortcuts settings"
msgstr "\"Nuba\" importo/eksporto por ŝparvojaj agordoj"

#: src/pages/settings.jsx:637
msgid "⚠️⚠️⚠️ Very experimental.<0/>Stored in your own profile’s notes. Profile (private) notes are mainly used for other profiles, and hidden for own profile."
msgstr "⚠️⚠️⚠️ Tre eksperimenta.<0/>Konservita en la notoj de via propra profilo. Profilaj (privataj) notoj estas ĉefe uzataj por aliaj profiloj, kaj kaŝitaj por propra profilo."

#: src/pages/settings.jsx:648
msgid "Note: This feature uses currently-logged-in instance server API."
msgstr "Noto: Ĉi tiu funkcio uzas la API de la aktuale ligita nodservilo."

#: src/pages/settings.jsx:665
msgid "Cloak mode <0>(<1>Text</1> → <2>████</2>)</0>"
msgstr "Ŝtelreĝimo <0>(<1>Teksto</1> → <2>████</2>)</0>"

#: src/pages/settings.jsx:674
msgid "Replace text as blocks, useful when taking screenshots, for privacy reasons."
msgstr "Anstataŭigi tekston kiel blokojn, utilajn kiam oni prenas ekrankopiojn, pro privatecaj kialoj."

#: src/pages/settings.jsx:699
msgid "About"
msgstr "Pri"

#: src/pages/settings.jsx:738
msgid "<0>Built</0> by <1>@cheeaun</1>"
msgstr "<0>Konstruita</0> de <1>@cheeaun</1>"

#: src/pages/settings.jsx:767
msgid "Sponsor"
msgstr "Patroni"

#: src/pages/settings.jsx:775
msgid "Donate"
msgstr "Donaci"

#: src/pages/settings.jsx:783
msgid "Privacy Policy"
msgstr "Privateca politiko"

#: src/pages/settings.jsx:790
msgid "<0>Site:</0> {0}"
msgstr "<0>Retejo:</0> {0}"

#: src/pages/settings.jsx:797
msgid "<0>Version:</0> <1/> {0}"
msgstr "<0>Versio:</0> <1/> {0}"

#: src/pages/settings.jsx:812
msgid "Version string copied"
msgstr "Versioĉeno kopiita"

#: src/pages/settings.jsx:815
msgid "Unable to copy version string"
msgstr "Ne eblas kopii versioĉenon"

#: src/pages/settings.jsx:1015
#: src/pages/settings.jsx:1020
msgid "Failed to update subscription. Please try again."
msgstr "Malsukcesis ĝisdatigi abonon. Bonvolu provi denove."

#: src/pages/settings.jsx:1026
msgid "Failed to remove subscription. Please try again."
msgstr "Malsukcesis forigi abonon. Bonvolu provi denove."

#: src/pages/settings.jsx:1033
msgid "Push Notifications (beta)"
msgstr "Puŝaj sciigoj (beta)"

#: src/pages/settings.jsx:1055
msgid "Push notifications are blocked. Please enable them in your browser settings."
msgstr "Puŝaj sciigoj estas blokitaj. Bonvolu aktivigi ilin en via retumila agordo."

#: src/pages/settings.jsx:1064
msgid "Allow from <0>{0}</0>"
msgstr "Permesi de <0>{0}</0>"

#: src/pages/settings.jsx:1073
msgid "anyone"
msgstr "iu ajn"

#: src/pages/settings.jsx:1077
msgid "people I follow"
msgstr "homoj, kiujn mi sekvas"

#: src/pages/settings.jsx:1081
msgid "followers"
msgstr "sekvantoj"

#: src/pages/settings.jsx:1114
msgid "Follows"
msgstr "Sekvas"

#: src/pages/settings.jsx:1122
msgid "Polls"
msgstr "Balotenketoj"

#: src/pages/settings.jsx:1126
msgid "Post edits"
msgstr "Redaktoj de la afiŝo"

#: src/pages/settings.jsx:1147
msgid "Push permission was not granted since your last login. You'll need to <0><1>log in</1> again to grant push permission</0>."
msgstr "Puŝo-permeso ne estis donita ekde via lasta ensaluto. Vi devos <0><1>ensaluti</1> denove por doni puŝo-permeson</0>."

#: src/pages/settings.jsx:1163
msgid "NOTE: Push notifications only work for <0>one account</0>."
msgstr "NOTO: Puŝaj sciigoj funkcias nur por <0>unu konto</0>."

#. js-lingui-explicit-id
#: src/pages/status.jsx:567
#: src/pages/status.jsx:1100
msgid "post.title"
msgstr "Afiŝo"

#: src/pages/status.jsx:791
msgid "You're not logged in. Interactions (reply, boost, etc) are not possible."
msgstr "Vi ne estas ensalutinta. Interagoj (respondi, diskonigi, ktp) ne eblas."

#: src/pages/status.jsx:811
msgid "This post is from another instance (<0>{instance}</0>). Interactions (reply, boost, etc) are not possible."
msgstr "Ĉi tiu afiŝo estas de alia nodo (<0>{instance}</0>). Interagoj (respondi, diskonigi, ktp) ne eblas."

#: src/pages/status.jsx:839
msgid "Error: {e}"
msgstr "Eraro: {e}"

#: src/pages/status.jsx:846
msgid "Switch to my instance to enable interactions"
msgstr "Iri al mia nodo por ŝalti interagojn"

#: src/pages/status.jsx:948
msgid "Unable to load replies."
msgstr "Ne eblas ŝargi respondojn."

#: src/pages/status.jsx:1060
msgid "Back"
msgstr "Reen"

#: src/pages/status.jsx:1091
msgid "Go to main post"
msgstr "Iri al ĉefa afiŝo"

#: src/pages/status.jsx:1114
msgid "{0} posts above ‒ Go to top"
msgstr "{0} afiŝoj supre ‒ Iri supren"

#: src/pages/status.jsx:1157
#: src/pages/status.jsx:1220
msgid "Switch to Side Peek view"
msgstr "Ŝalti al Flanka Vido"

#: src/pages/status.jsx:1221
msgid "Switch to Full view"
msgstr "Ŝalti al Plena Vido"

#: src/pages/status.jsx:1239
msgid "Show all sensitive content"
msgstr "Montri ĉiujn sentemajn enhavojn"

#: src/pages/status.jsx:1244
msgid "Experimental"
msgstr "Eksperimenta"

#: src/pages/status.jsx:1253
msgid "Unable to switch"
msgstr "Ne eblas ŝalti"

#: src/pages/status.jsx:1260
msgid "Switch to post's instance ({0})"
msgstr "Iri al nodo de la afiŝo ({0})"

#: src/pages/status.jsx:1263
msgid "Switch to post's instance"
msgstr "Iri al la nodo de la afiŝo"

#: src/pages/status.jsx:1321
msgid "Unable to load post"
msgstr "Ne eblas ŝargi afiŝon"

#: src/pages/status.jsx:1438
msgid "{0, plural, one {# reply} other {<0>{1}</0> replies}}"
msgstr "{0, plural, one {# respondo} other {<0>{1}</0> respondoj}}"

#: src/pages/status.jsx:1456
msgid "{totalComments, plural, one {# comment} other {<0>{0}</0> comments}}"
msgstr "{totalComments, plural, one {# komento} other {<0>{0}</0> komentoj}}"

#: src/pages/status.jsx:1478
msgid "View post with its replies"
msgstr "Vidi afiŝon kun siaj respondoj"

#: src/pages/trending.jsx:71
msgid "Trending ({instance})"
msgstr "Populara ({instance})"

#: src/pages/trending.jsx:228
msgid "Trending News"
msgstr "Popularaj Novaĵoj"

#. By [Author]
#: src/pages/trending.jsx:347
msgid "By {0}"
msgstr "Per {0}"

#: src/pages/trending.jsx:408
msgid "Back to showing trending posts"
msgstr "Reen al montrado de popularaj afiŝoj"

#: src/pages/trending.jsx:413
msgid "Showing posts mentioning <0>{0}</0>"
msgstr "Montrante afiŝojn kiuj mencias <0>{0}</0>"

#: src/pages/trending.jsx:425
msgid "Trending posts"
msgstr "Popularaj afiŝoj"

#: src/pages/trending.jsx:448
msgid "No trending posts."
msgstr "Neniuj popularaj afiŝoj."

#: src/pages/welcome.jsx:53
msgid "A minimalistic opinionated Mastodon web client."
msgstr "Minimuma retkliento por Mastodon, kiu faras aferojn laŭ via maniero."

#: src/pages/welcome.jsx:64
msgid "Log in with Mastodon"
msgstr "Ensaluti per Mastodon"

#: src/pages/welcome.jsx:70
msgid "Sign up"
msgstr "Aliĝi"

#: src/pages/welcome.jsx:77
msgid "Connect your existing Mastodon/Fediverse account.<0/>Your credentials are not stored on this server."
msgstr "Konekti vian ekzistantan Mastodon/Fediverson-konton.<0/>Viaj ensalutiloj ne estas konservitaj en ĉi tiu servilo."

#: src/pages/welcome.jsx:94
msgid "<0>Built</0> by <1>@cheeaun</1>. <2>Privacy Policy</2>."
msgstr "<0>Konstruita</0> de <1>@cheeaun</1>. <2>Regularo pri privateco</2>."

#: src/pages/welcome.jsx:125
msgid "Screenshot of Boosts Carousel"
msgstr "Ekrankopio de Karuselon de diskonigoj"

#: src/pages/welcome.jsx:129
msgid "Boosts Carousel"
msgstr "Karuselon de diskonigoj"

#: src/pages/welcome.jsx:132
msgid "Visually separate original posts and re-shared posts (boosted posts)."
msgstr "Vide apartigu originalajn afiŝojn kaj redividitajn afiŝojn (diskonigitajn afiŝojn)."

#: src/pages/welcome.jsx:141
msgid "Screenshot of nested comments thread"
msgstr "Ekrankopio de grupigita komenta fadeno"

#: src/pages/welcome.jsx:145
msgid "Nested comments thread"
msgstr "Grupigita komenta fadeno"

#: src/pages/welcome.jsx:148
msgid "Effortlessly follow conversations. Semi-collapsible replies."
msgstr "Sekvi konversaciojn perfekte. Duonfaldeblaj respondoj."

#: src/pages/welcome.jsx:156
msgid "Screenshot of grouped notifications"
msgstr "Ekrankopio de grupigitaj sciigoj"

#: src/pages/welcome.jsx:160
msgid "Grouped notifications"
msgstr "Grupigitaj sciigoj"

#: src/pages/welcome.jsx:163
msgid "Similar notifications are grouped and collapsed to reduce clutter."
msgstr "Similaj sciigoj estas grupigitaj kaj kolapsitaj por redukti malordon."

#: src/pages/welcome.jsx:172
msgid "Screenshot of multi-column UI"
msgstr "Ekrankopio de plurkolumna uzantinterfaco"

#: src/pages/welcome.jsx:176
msgid "Single or multi-column"
msgstr "Ununuro aŭ plurkolumno"

#: src/pages/welcome.jsx:179
msgid "By default, single column for zen-mode seekers. Configurable multi-column for power users."
msgstr "Defaŭlte, ununura kolumno por serĉantoj de zen-reĝimo. Agordebla plurkolumno por altnivelaj uzantoj."

#: src/pages/welcome.jsx:188
msgid "Screenshot of multi-hashtag timeline with a form to add more hashtags"
msgstr "Ekrankopio de plurkradvorta templinio kun formo por aldoni pliajn kradvortojn"

#: src/pages/welcome.jsx:192
msgid "Multi-hashtag timeline"
msgstr "Plurkradvorta templinio"

#: src/pages/welcome.jsx:195
msgid "Up to 5 hashtags combined into a single timeline."
msgstr "Ĝis 5 kradvortoj kombinitaj en ununuran templinion."

#: src/utils/open-compose.js:24
msgid "Looks like your browser is blocking popups."
msgstr "Ŝajnas, ke via retumilo blokas ŝprucfenestrojn."

#: src/utils/show-compose.js:16
msgid "A draft post is currently minimized. Post or discard it before creating a new one."
msgstr "Malneto afiŝo estas nuntempe minimumigita. Afiŝu aŭ forĵetu ĝin antaŭ ol krei novan."

#: src/utils/show-compose.js:21
msgid "A post is currently open. Post or discard it before creating a new one."
msgstr "Afiŝo estas nuntempe malfermita. Afiŝu aŭ forĵetu ĝin antaŭ ol krei novan."

